if(window.location.pathname.includes('/products/')){
    window.PreorderManager = {

  /* --------------------------------------------------------------------------
   * GLOBAL CONFIG
   * -------------------------------------------------------------------------- */
  config: {
    daysUntilShip: 30,
    defaultQuantity: 1,
    messagePrefix: '',
    propertyKey: 'Estimated to Ship',
    waitTimeout: 10000,
    debug: true,
    autoOpenCart: true,

    // Master kill switch for ALL pre-order logic. When true: the pre-order
    // button is never created, no pre-order styles or Kaching pre-order
    // labels are injected, every color/variant is treated as in-stock
    // (ATC never disabled), and only the regular Add-to-Cart button with
    // normal prices is shown.
    disablePreorder: true,

    preorderButton: {
      enabled: true,
      containerSelector: 'gp-product-button',
      id: 'cm-preorder-btn',
      debounceMs: 120,
    },

    // Price probe: fetches a known-USD product in the current currency
    // to derive cart's effective conversion rate. Per-product config can
    // opt in with `useProbeRateDiscount: true`. When enabled, the
    // preorder discount is computed as `probeRate × usdAmount` instead
    // of using Shopify.currency.rate or the exact-variant-diff path.
    //
    // Note: this assumes the probe product uses the same conversion
    // mechanism as the products you're labeling. If your Shopify Markets
    // setup has manual price overrides on specific products, the probe
    // rate won't reflect those overrides — debug logs will show the
    // observed rate so you can verify.
    priceProbe: {
      handle: 'dollar',  // product handle for the probe
      usdValue: 1,       // its price in base currency (USD)
    },

    atcButton: {
      enabled: true,
      selector: 'button.gp-button-atc, button.gp-button-sold-out',
      enhancedClass: 'cm-atc-btn',
      debounceMs: 120,
    },

    stickyAtc: {
      enabled: true,
      id: 'stickyAtc',
      // Ordered list — sticky bar appears once the viewer scrolls past the
      // first one that exists on the page.
      triggerSelectors: ['#cm-preorder-btn', '.cm-atc-btn', 'button.gp-button-atc'],
      footerSelector: 'footer',
      // Variant thumbnails shared across all products using the same image set.
      // Per-product `variantImages: { 'Color|Model': url }` (or `'Model': url`
      // for products without a color option) on a PRODUCT entry wins over
      // these defaults. If neither is defined for a variant, the sticky
      // falls back to a color swatch.
      defaultVariantImages: {
        'Rose|Classic':            'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/ProductImage1_1_693a2a83-932b-4e63-a304-ea7774b387be.jpg?v=1764877281',
        'Charcoal|Classic':        'https://luhxe.com/cdn/shop/files/hf_20260507_143249_74055416-3ea2-4ff3-9399-79266e9d494a_1_1.png?v=1778253093&width=400',
        'Snow|Classic':            'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/Frame2_1.jpg?v=1774632224',
        'Rose|Roller Edition':     'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/2_6058d258-0911-440b-a89d-4305a5628e3f.jpg?v=1774632224',
        'Charcoal|Roller Edition': 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/hf_20260508_173801_2477cee8-d7de-42bd-a7e8-fc6214b3b5c7.png?v=1778693511',
        'Snow|Roller Edition':     'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/3_abd3b251-d5f3-471d-8f79-b03ec78a8f88.jpg?v=1774632224',
      },
      scrollToSelectorOnTap: '.product-variant--heading',
    },

    initialSync: { maxMs: 3500, intervalMs: 80 },

    /* ─── PRE-ORDER PRODUCT HANDLES ───────────────────────────────────
     * Map from a main product handle to the hidden Shopify product that
     * holds its pre-order variants. Used to fetch localized variant
     * prices via /products/{handle}.js so the displayed pre-order price
     * matches cart to the cent in every currency.
     *
     * Without an entry for a given handle, the pre-order label falls
     * back to rate-based math (Shopify.currency.rate × discount.amount),
     * which drifts in markets with manually-set EUR/GBP/etc. prices.
     *
     * EDIT HANDLES HERE. To override at runtime (e.g. for testing):
     *   PreorderManager.config.preorderHandles['my-handle'] = 'my-preorder-handle';
     *   sessionStorage.clear();                            // bust price cache
     *   PreorderManager.state._localizedPrices = null;
     *   PreorderManager.state._localizedPricesPromise = null;
     *   PreorderManager._ensureLocalizedPrices().then(() => {
     *     PreorderManager.updateKachingBarPreorderLabels();
     *   });
     * ─────────────────────────────────────────────────────────────── */
    preorderHandles: {
      'luhxe':         'luhxe-travel-bag-2-0-preorder-copy',
      'luhxe-0':       'luhxe-travel-bag-2-0-preorder-copy',
      'luhxe-1':       'luhxe-travel-bag-2-0-preorder-copy',
      'luhxe-2':       'luhxe-travel-bag-2-0-preorder-copy',
      'luhxe-offer-5':  'luhxe-offer-5-preorder',
      'luhxe-offer-1': 'luhxe-travel-bag-2-0-preorder-free-shipping',
      'the-black-bag': 'the-black-bag-new-preorder',
      'luhxe-travel-bag-2-0-international-womens-day': 'luhxe-travel-bag-2-0-international-womens-day-pre-order',
      'luhxe-travel-bag-2-0-easter-sale': 'luhxe-travel-bag-2-0-easter-offer-pre-order',
      'luhxe-travel-bag-2-0-anti-tarriff-sale': 'luhxe-travel-bag-2-0-anti-tariff-flash-sale-preorder',
      'luhxe-travel-bag-2-0-mothers-day-sale': 'luhxe-travel-bag-2-0-mothers-day-sale-preorder',
      'luhxe-travel-bag-2-0-copy':       'luhxe-travel-bag-2-0-preorder-copy',
    },

    // Kaching DOM hooks — adjust only if Kaching's markup changes.
    kaching: {
      barScope:             '.gRIZVyRVsx',
      selectedBarSelector:  '.kaching-bundles__bar.kaching-bundles__bar--selected',
      variantBlockSelector: '.kaching-bundles__bar-variant-selects',
      // IMPORTANT: every selector excludes .cm-kaching-preorder-label
      // (the label we inject above each bar's price). Without that
      // exclusion, the generic ">span" selector matches our OWN label on
      // the next mutation pass, and we end up re-discounting the already-
      // discounted price — visible as stacked "Pre-Order: Pre-Order: ..."
      // prefixes and a too-low number.
      salePriceSelectors: [
        '.kaching-bundles__bar-price .kaching-bundles__bar-price-now:not(.cm-kaching-preorder-label)',
        '.kaching-bundles__bar-price .money:not(del):not(s):not(.cm-kaching-preorder-label)',
        '.kaching-bundles__bar-price [data-vitals-cc]:not(del):not(s):not(.cm-kaching-preorder-label)',
        '.kaching-bundles__bar-price > span:not(del):not(s):not(.kaching-bundles__bar-price-compare):not(.kaching-bundles__bar-price-was):not(.cm-kaching-preorder-label)',
        '.kaching-bundles__bar-price',
      ],
      comparePriceSelectors: [
        '.kaching-bundles__bar-full-price:not(.cm-kaching-preorder-label)',
        '.kaching-bundles__bar-price-compare:not(.cm-kaching-preorder-label)',
        '.kaching-bundles__bar-price-was:not(.cm-kaching-preorder-label)',
        '.kaching-bundles__bar-price s',
        '.kaching-bundles__bar-price del',
      ],
      // ATTRIBUTE carrying the ORIGINAL (base-currency) numeric price, used
      // to convert fixed USD discounts into the displayed currency. The value
      // looks like "$179" and lives on the same element (or a descendant) as
      // the displayed localized price. Default targets Vitals Currency
      // Converter — change if you switch apps.
      baseCurrencyAttr: 'data-vitals-cc-usd',

      // Small "Pre-Order: $X" label injected above each Kaching bar's price.
      // Shown in every currency now (was USD-only). The prefix is swapped
      // for the localized string at init() when the URL is a Spanish one.
      showPreorderLabels:   true,
      preorderLabelPrefix:  'Pre-Order:',
    },
  },

  /* --------------------------------------------------------------------------
   * I18N  —  localized copy
   * --------------------------------------------------------------------------
   * Every customer-facing string the script injects lives here. The active
   * language is derived from the URL by getLocale():
   *
   *   /es-es/products/luhxe   → 'es'
   *   /es/products/luhxe      → 'es'
   *   /products/luhxe         → 'en'
   *
   * Anything missing from a non-English map falls back to the English
   * string, so a partial translation is safe.
   *
   * NOTE: `propertyKey` is the cart line-item property name (shown to the
   * customer in cart/checkout), so it is translated too. It is applied to
   * config.propertyKey in init() unless a custom value was passed in.
   * -------------------------------------------------------------------------- */
  I18N: {
    en: {
      months: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
      propertyKey:          'Estimated to Ship',
      preorderLabelPrefix:  'Pre-Order:',

      // Pre-order button (PDP)
      preorderBtnLabel:     'ADD PRE-ORDER',
      waitAndSave:          'Wait & Save:',
      estimatedToShip:      'Estimated to Ship',

      // Add-to-cart button (PDP)
      atcLabel:             'ADD TO CART',
      soldOutLabel:         'SOLD OUT',
      inStockReady:         'In-Stock: Ready to Ship',
      availableIn:          'Available in',
      listAnd:              'and',

      // Sticky bar
      stickyAria:           'Quick add to cart',
      stickyLoading:        'Loading…',
      stickyAddToCart:      'Add to cart',
      stickySoldOut:        'Sold Out',
      stickyPreorder:       'Pre-order',
      stickyPreorderNow:    'Pre-order now',
      stickyShipsSoon:      'Wait & Save: Ships soon',
      stickyShipsOn:        'Wait & Save: Ships {date}',
      stickyWaitSave:       'Wait & Save',
    },

    es: {
      months: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'],
      propertyKey:          'Envío estimado',
      preorderLabelPrefix:  'Pre-orden:',

      // Pre-order button (PDP)
      preorderBtnLabel:     'AÑADIR PRE-ORDEN',
      waitAndSave:          'Espera y ahorra:',
      estimatedToShip:      'Envío estimado el',

      // Add-to-cart button (PDP)
      atcLabel:             'AÑADIR AL CARRITO',
      soldOutLabel:         'AGOTADO',
      inStockReady:         'En stock: Listo para enviar',
      availableIn:          'Disponible en',
      listAnd:              'y',

      // Sticky bar
      stickyAria:           'Añadir al carrito rápido',
      stickyLoading:        'Cargando…',
      stickyAddToCart:      'Añadir al carrito',
      stickySoldOut:        'Agotado',
      stickyPreorder:       'Pre-ordenar',
      stickyPreorderNow:    'Pre-ordena ahora',
      stickyShipsSoon:      'Espera y ahorra: Envío pronto',
      stickyShipsOn:        'Espera y ahorra: Envío el {date}',
      stickyWaitSave:       'Espera y ahorra',
    },
  },

  /**
   * Resolve the active language from the URL. Shopify Markets puts the
   * locale in the FIRST path segment (/es-es/products/…), so that's what
   * we read. A plain `es-es` anywhere in the href is accepted as a
   * fallback for setups that pass it as a query param.
   *
   * Memoized — the locale can't change without a page load.
   */
  getLocale() {
    if (this.state._locale) return this.state._locale;
    let loc = 'en';
    try {
      const parts = window.location.pathname.toLowerCase().split('/').filter(Boolean);
      const first = parts[0] || '';
      if (first === 'es-es' || first === 'es' || first.startsWith('es-')) {
        loc = 'es';
      } else if (window.location.href.toLowerCase().includes('es-es')) {
        loc = 'es';
      }
    } catch (_) {}
    this.state._locale = loc;
    return loc;
  },

  /**
   * Look up a localized string. Falls back to English for any key the
   * active language doesn't define. `vars` supports {placeholder} tokens:
   *   this.t('stickyShipsOn', { date: 'Jan 5th' })
   */
  t(key, vars = null) {
    const loc  = this.getLocale();
    const pack = this.I18N[loc] || this.I18N.en;
    let str = (pack && pack[key] != null) ? pack[key] : this.I18N.en[key];
    if (str == null) return '';
    if (vars) {
      for (const k of Object.keys(vars)) {
        str = String(str).split(`{${k}}`).join(vars[k]);
      }
    }
    return str;
  },

  /** Month names for the active language (falls back to dateConfig.months). */
  getMonthNames() {
    const loc = this.getLocale();
    const pack = this.I18N[loc];
    if (loc !== 'en' && Array.isArray(pack?.months)) return pack.months;
    return this.dateConfig.months;
  },

  /* --------------------------------------------------------------------------
   * SCHEMA DEFAULTS
   * --------------------------------------------------------------------------
   * Each PRODUCT entry can optionally define a `schema` to describe how its
   * Shopify/Kaching variant options are structured. Fields:
   *   • colorOptionName   — Shopify option name for the color, or null when
   *                         the product has no color option at all.
   *   • modelOptionName   — Shopify option name for the model/edition.
   *   • modelMap          — Maps the raw value seen in the DOM (e.g. Kaching's
   *                         data-value) to the CANONICAL key used in IDS,
   *                         preorderIDS, and offer-state logic. Lets a product
   *                         that calls its variant "Roller" be treated as
   *                         "Roller Edition" internally.
   *
   * Products without a schema fall back to the Luhxe shape (Color + Model
   * with values Classic / Roller Edition).
   * -------------------------------------------------------------------------- */
  DEFAULT_SCHEMA: {
    colorOptionName: 'Color',
    modelOptionName: 'Model',
    modelMap: {
      'Classic':        'Classic',
      'Roller Edition': 'Roller Edition',
    },
  },

  /* --------------------------------------------------------------------------
   * PRODUCT CATALOG  —  add new products here
   * -------------------------------------------------------------------------- */
  PRODUCTS: {
    // Only products listed here are touched. Unlisted handles → script is inert.

    'luhxe': {
      IDS: {
        Rose:     { 'Roller Edition': '42999658446895', Classic: '42119283179567' },
        Charcoal: { 'Roller Edition': '42999658381359', Classic: '42119283146799' },
        Snow:     { 'Roller Edition': '42999658414127', Classic: '42119283114031' },
      },
      preorderIDS: {
        Rose:     { 'Roller Edition': '44976484417583', Classic: '44976484384815' },
        Charcoal: { 'Roller Edition': '44976484483119', Classic: '44976484450351' },
        Snow:     { 'Roller Edition': '44976484548655', Classic: '44976484515887' },
      },
      SINGLE_ID: '31d2a68d-ae0d-4cd1-8c47-15b90ef32d9c',
      DOUBLE_ID: '28af1ba7-b234-4be1-a7ed-707e6b6f7bfa',
      colorStock: {
        Rose:     'disabled',
        Charcoal: 'disabled',
        Snow:     'available',
      },
      preorderDiscount: {
        default: { type: 'fixed', amount: 10 },
        double:  { type: 'fixed', amount: 20 },
      },
    },

    'luhxe-bag': {
      IDS: {
        Rose:     { 'Roller Edition': '46269483417647', Classic: '46269483384879' },
        Charcoal: { 'Roller Edition': '46269483483183', Classic: '46269483450415' },
        Snow:     { 'Roller Edition': '46269483548719', Classic: '46269483515951' },
      },
      preorderIDS: {
        Rose:     { 'Roller Edition': '44976484417583', Classic: '44976484384815' },
        Charcoal: { 'Roller Edition': '44976484483119', Classic: '44976484450351' },
        Snow:     { 'Roller Edition': '44976484548655', Classic: '44976484515887' },
      },
      SINGLE_ID: '31d2a68d-ae0d-4cd1-8c47-15b90ef32d9c',
      DOUBLE_ID: '28af1ba7-b234-4be1-a7ed-707e6b6f7bfa',
      colorStock: {
        Rose:     'disabled',
        Charcoal: 'disabled',
        Snow:     'available',
      },
      preorderDiscount: {
        default: { type: 'fixed', amount: 10 },
        double:  { type: 'fixed', amount: 20 },
      },
    },
    
    'luhxe-summer-sale': {
      IDS: {
        Rose:     { 'Roller Edition': '45630944477231', Classic: '45630944444463' },
        Charcoal: { 'Roller Edition': '45630944542767', Classic: '45630944509999' },
        Snow:     { 'Roller Edition': '45630944608303', Classic: '45630944575535' },
      },
      preorderIDS: {
        Rose:     { 'Roller Edition': '44976484417583', Classic: '44976484384815' },
        Charcoal: { 'Roller Edition': '44976484483119', Classic: '44976484450351' },
        Snow:     { 'Roller Edition': '44976484548655', Classic: '44976484515887' },
      },
      SINGLE_ID: '31d2a68d-ae0d-4cd1-8c47-15b90ef32d9c',
      DOUBLE_ID: '28af1ba7-b234-4be1-a7ed-707e6b6f7bfa',
      colorStock: {
        Rose:     'disabled',
        Charcoal: 'disabled',
        Snow:     'available',
      },
      preorderDiscount: {
        default: { type: 'fixed', amount: 10 },
        double:  { type: 'fixed', amount: 20 },
      },
    },

    'luhxe-roller': {
      IDS: {
        Rose:     { 'Roller Edition': '45642106667055', Classic: '45630944444463' },
        Charcoal: { 'Roller Edition': '45642106732591', Classic: '45630944509999' },
        Snow:     { 'Roller Edition': '45642106798127', Classic: '45630944575535' },
      },
      preorderIDS: {
        Rose:     { 'Roller Edition': '44976484417583', Classic: '44976484384815' },
        Charcoal: { 'Roller Edition': '44976484483119', Classic: '44976484450351' },
        Snow:     { 'Roller Edition': '44976484548655', Classic: '44976484515887' },
      },
      SINGLE_ID: '31d2a68d-ae0d-4cd1-8c47-15b90ef32d9c',
      DOUBLE_ID: '28af1ba7-b234-4be1-a7ed-707e6b6f7bfa',
      colorStock: {
        Rose:     'disabled',
        Charcoal: 'disabled',
        Snow:     'available',
      },
      preorderDiscount: {
        default: { type: 'fixed', amount: 10 },
        double:  { type: 'fixed', amount: 20 },
      },
    },

    'luhxe-travel-bag-2-0': {
      IDS: {
        Rose:     { 'Roller Edition': '42999658446895', Classic: '42119283179567' },
        Charcoal: { 'Roller Edition': '42999658381359', Classic: '42119283146799' },
        Snow:     { 'Roller Edition': '42999658414127', Classic: '42119283114031' },
      },
      preorderIDS: {
        Rose:     { 'Roller Edition': '44976484417583', Classic: '44976484384815' },
        Charcoal: { 'Roller Edition': '44976484483119', Classic: '44976484450351' },
        Snow:     { 'Roller Edition': '44976484548655', Classic: '44976484515887' },
      },
      SINGLE_ID: '31d2a68d-ae0d-4cd1-8c47-15b90ef32d9c',
      DOUBLE_ID: '28af1ba7-b234-4be1-a7ed-707e6b6f7bfa',
      colorStock: {
        Rose:     'disabled',
        Charcoal: 'disabled',
        Snow:     'available',
      },
      preorderDiscount: {
        default: { type: 'fixed', amount: 10 },
        double:  { type: 'fixed', amount: 20 },
      },
    },

    'luhxe-0': {
      IDS: {
        Rose:     { 'Roller Edition': '42999658446895', Classic: '42119283179567' },
        Charcoal: { 'Roller Edition': '42999658381359', Classic: '42119283146799' },
        Snow:     { 'Roller Edition': '42999658414127', Classic: '42119283114031' },
      },
      preorderIDS: {
        Rose:     { 'Roller Edition': '44976484417583', Classic: '44976484384815' },
        Charcoal: { 'Roller Edition': '44976484483119', Classic: '44976484450351' },
        Snow:     { 'Roller Edition': '44976484548655', Classic: '44976484515887' },
      },
      SINGLE_ID: '31d2a68d-ae0d-4cd1-8c47-15b90ef32d9c',
      DOUBLE_ID: '28af1ba7-b234-4be1-a7ed-707e6b6f7bfa',
      colorStock: {
        Rose:     'disabled',
        Charcoal: 'disabled',
        Snow:     'available',
      },
      preorderDiscount: {
        default: { type: 'fixed', amount: 10 },
        double:  { type: 'fixed', amount: 20 },
      },
    },

    'luhxe-travel-bag-2-0-labor-day-sale': {
      IDS: {
        Rose:  { 'Roller Edition': '46102424059951', Classic: '46102424027183' },
        Snow:  { 'Roller Edition': '46102424191023', Classic: '46102424158255' },
      },
      preorderIDS: {
        Rose:     { 'Roller Edition': '44976484417583', Classic: '44976484384815' },
        Charcoal: { 'Roller Edition': '44976484483119', Classic: '44976484450351' },
        Snow:     { 'Roller Edition': '44976484548655', Classic: '44976484515887' },
      },
      SINGLE_ID: '1a2d7e49-6f83-4f34-9ddb-d40e7fc18248',
      DOUBLE_ID: '7af5474d-47f7-4d16-908e-02741f19546e',
      colorStock: {
        Rose:     'disabled',
        Charcoal: 'disabled',
        Snow:     'available',
      },
      preorderDiscount: {
        default: { type: 'fixed', amount: 10 },
        double:  { type: 'fixed', amount: 20 },
      },
    },

    'luhxe-travel-bag-2-0-fall-sale': {
      IDS: {
        Rose:     { 'Roller Edition': '46247360331823', 'Classic': '46247360299055' },
        Charcoal: { 'Roller Edition': '46247360397359', 'Classic': '46247360364591' },
        Snow:     { 'Roller Edition': '46247360462895', 'Classic': '46247360430127' },
      },
      preorderIDS: {
        Rose:     { 'Roller Edition': '44976484417583', Classic: '44976484384815' },
        Charcoal: { 'Roller Edition': '44976484483119', Classic: '44976484450351' },
        Snow:     { 'Roller Edition': '44976484548655', Classic: '44976484515887' },
      },
      SINGLE_ID: 'cdb81ed0-db54-414e-a944-c5888ba630ad',
      DOUBLE_ID: '015fcf0a-9815-483a-b0fa-58ccfd5d53a6',
      colorStock: {
        Rose:     'disabled',
        Charcoal: 'disabled',
        Snow:     'available',
      },
      preorderDiscount: {
        default: { type: 'fixed', amount: 10 },
        double:  { type: 'fixed', amount: 20 },
      },
    },

    'luhxe-2': {
      IDS: {
        Rose:     { 'Roller Edition': '42999658446895', Classic: '42119283179567' },
        Charcoal: { 'Roller Edition': '42999658381359', Classic: '42119283146799' },
        Snow:     { 'Roller Edition': '42999658414127', Classic: '42119283114031' },
      },
      preorderIDS: {
        Rose:     { 'Roller Edition': '44976484417583', Classic: '44976484384815' },
        Charcoal: { 'Roller Edition': '44976484483119', Classic: '44976484450351' },
        Snow:     { 'Roller Edition': '44976484548655', Classic: '44976484515887' },
      },
      SINGLE_ID: '31d2a68d-ae0d-4cd1-8c47-15b90ef32d9c',
      DOUBLE_ID: '28af1ba7-b234-4be1-a7ed-707e6b6f7bfa',
      colorStock: {
        Rose:     'disabled',
        Charcoal: 'disabled',
        Snow:     'available',
      },
      preorderDiscount: {
        default: { type: 'fixed', amount: 10 },
        double:  { type: 'fixed', amount: 20 },
      },
    },

    'luhxe-1': {
      IDS: {
        Rose:     { 'Roller Edition': '42999658446895', Classic: '42119283179567' },
        Charcoal: { 'Roller Edition': '42999658381359', Classic: '42119283146799' },
        Snow:     { 'Roller Edition': '42999658414127', Classic: '42119283114031' },
      },
      preorderIDS: {
        Rose:     { 'Roller Edition': '44976484417583', Classic: '44976484384815' },
        Charcoal: { 'Roller Edition': '44976484483119', Classic: '44976484450351' },
        Snow:     { 'Roller Edition': '44976484548655', Classic: '44976484515887' },
      },
      SINGLE_ID: '31d2a68d-ae0d-4cd1-8c47-15b90ef32d9c',
      DOUBLE_ID: '28af1ba7-b234-4be1-a7ed-707e6b6f7bfa',
      colorStock: {
        Rose:     'disabled',
        Charcoal: 'disabled',
        Snow:     'available',
      },
      preorderDiscount: {
        default: { type: 'fixed', amount: 10 },
        double:  { type: 'fixed', amount: 20 },
      },
    },

    'luhxe-offer-5': {
    IDS: {
      Rose:     { 'Roller Edition': '45522745655343', Classic: '45522745622575' },
      Charcoal: { 'Roller Edition': '45522745720879', Classic: '45522745688111' },
      Snow:     { 'Roller Edition': '45522745786415', Classic: '45522745753647' },
    },
    preorderIDS: {
      Rose:     { 'Roller Edition': '45522747064367', Classic: '45522747031599' },
      Charcoal: { 'Roller Edition': '45522747129903', Classic: '45522747097135' },
      Snow:     { 'Roller Edition': '45522747195439', Classic: '45522747162671' },
    },
    SINGLE_ID: '1fbfdb64-e687-43a4-aa39-4db04299fa1c', // "Buy 1" bar
DOUBLE_ID: 'd9420624-f869-4ede-a8a8-db90709270a1', // "Buy 2 & Save 30%" bar
    colorStock: {
      Rose:     'available', // ⚠️ verify against actual stock
      Charcoal: 'available',
      Snow:     'available',
    },
    preorderDiscount: {
      default: { type: 'fixed', amount: 10 },
      double:  { type: 'fixed', amount: 30 },
    },
  },
  'luhxe-travel-bag-2-0-offer': {
    IDS: {
      Rose:     { 'Roller Edition': '45865784049711', Classic: '45865784016943' },
      Charcoal: { 'Roller Edition': '45865784115247', Classic: '45865784082479' },
      Snow:     { 'Roller Edition': '45865784180783', Classic: '45865784148015' },
    },
    preorderIDS: {
      Rose:     { 'Roller Edition': '45522747064367', Classic: '45522747031599' },
      Charcoal: { 'Roller Edition': '45522747129903', Classic: '45522747097135' },
      Snow:     { 'Roller Edition': '45522747195439', Classic: '45522747162671' },
    },
    SINGLE_ID: '31d2a68d-ae0d-4cd1-8c47-15b90ef32d9c', // "Buy 1" bar
DOUBLE_ID: '28af1ba7-b234-4be1-a7ed-707e6b6f7bfa', // "Buy 2 & Save 30%" bar
    colorStock: {
      Rose:     'available', // ⚠️ verify against actual stock
      Charcoal: 'available',
      Snow:     'available',
    },
    preorderDiscount: {
      default: { type: 'fixed', amount: 10 },
      double:  { type: 'fixed', amount: 30 },
    },
  },

  'luhxe-travel-bag-2-offer': {
    IDS: {
      Rose:     { 'Roller Edition': '45885757227055', Classic: '45885757194287' },
      Charcoal: { 'Roller Edition': '45885757292591', Classic: '45885757259823' },
      Snow:     { 'Roller Edition': '45885757358127', Classic: '45885757325359' },
    },
    preorderIDS: {
      Rose:     { 'Roller Edition': '45522747064367', Classic: '45522747031599' },
      Charcoal: { 'Roller Edition': '45522747129903', Classic: '45522747097135' },
      Snow:     { 'Roller Edition': '45522747195439', Classic: '45522747162671' },
    },
    SINGLE_ID: '31d2a68d-ae0d-4cd1-8c47-15b90ef32d9c', // "Buy 1" bar
DOUBLE_ID: '28af1ba7-b234-4be1-a7ed-707e6b6f7bfa', // "Buy 2 & Save 30%" bar
    colorStock: {
      Rose:     'available', // ⚠️ verify against actual stock
      Charcoal: 'available',
      Snow:     'available',
    },
    preorderDiscount: {
      default: { type: 'fixed', amount: 10 },
      double:  { type: 'fixed', amount: 30 },
    },
  },
  
  'luhxe-offer-6': {
      IDS: {
        Rose:     { 'Roller Edition': '45539406610479', Classic: '45539406577711' },
        Charcoal: { 'Roller Edition': '45539406676015', Classic: '45539406643247' },
        Snow:     { 'Roller Edition': '45539406741551', Classic: '45539406708783' },
      },
      preorderIDS: {
        Rose:     { 'Roller Edition': '44976484417583', Classic: '44976484384815' },
        Charcoal: { 'Roller Edition': '44976484483119', Classic: '44976484450351' },
        Snow:     { 'Roller Edition': '44976484548655', Classic: '44976484515887' },
      },
      SINGLE_ID: '31d2a68d-ae0d-4cd1-8c47-15b90ef32d9c',
      DOUBLE_ID: '28af1ba7-b234-4be1-a7ed-707e6b6f7bfa',
      colorStock: {
        Rose:     'disabled',
        Charcoal: 'disabled',
        Snow:     'available',
      },
      preorderDiscount: {
        default: { type: 'fixed', amount: 10 },
        double:  { type: 'fixed', amount: 20 },
      },
    },

 'luhxe-travel-bag-2-0-copy': {
      IDS: {
        Rose:     { 'Roller Edition': '45430453207087', Classic: '45430453174319' },
        Charcoal: { 'Roller Edition': '45430453272623', Classic: '45430453239855' },
        Snow:     { 'Roller Edition': '45430453338159', Classic: '45430453305391' },
      },
      preorderIDS: {
        Rose:     { 'Roller Edition': '44976484417583', Classic: '44976484384815' },
        Charcoal: { 'Roller Edition': '44976484483119', Classic: '44976484450351' },
        Snow:     { 'Roller Edition': '44976484548655', Classic: '44976484515887' },
      },
      SINGLE_ID: '8420c2b8-b91e-4b26-9d0d-857ac0b5e09d',
      DOUBLE_ID: '75b1dd43-90ea-4a15-9925-0c503195b973',
      colorStock: {
        Rose:     'available',
        Charcoal: 'available',
        Snow:     'available',
      },
      // Duplicate PDP: Kaching can sync GemPages to sold-out variants on the
      // source product. bypassGemPagesAtc forces our IDS + custom cart submit.
      bypassGemPagesAtc: true,
      preorderDiscount: {
        default: { type: 'fixed', amount: 10 },
        double:  { type: 'fixed', amount: 20 },
      },
    },
    // ─── The Black Bag — single "Variant" option, no color, "Roller" instead
    // of "Roller Edition". Schema below normalizes that to the canonical
    // form so the rest of the code stays uniform.
    'the-black-bag': {
      schema: {
        colorOptionName: null,
        modelOptionName: 'Variant',
        modelMap: {
          'Classic': 'Classic',
          'Roller':  'Roller Edition',
        },
      },
      // Flat IDS (no color nesting) keyed by CANONICAL model name.
      IDS: {
        Classic:          '44558516322351',
        'Roller Edition': '44558516355119',
      },
      preorderIDS: {
        Classic:          '45323435933743',
        'Roller Edition': '45323435966511',
      },
      SINGLE_ID: 'b1897fed-34eb-4581-91ec-ea5a4eceb122',
      DOUBLE_ID: 'd2842793-1454-4991-a371-5b82e0ad7655',
      // No colors → empty stock map. hasColorVariants() short-circuits.
      colorStock: {},
      // Both regular variants are disabled — force pre-order. Keyed by the
      // CANONICAL model name (after normalizeModelValue), not Kaching's
      // raw "Roller" value.
      modelStock: {
        'Classic':        'disabled',
        'Roller Edition': 'disabled',
      },
      // Variant thumbnails for this product (flat — no color prefix).
      variantImages: {
        'Classic':        'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/4.jpg?v=1759958304',
        'Roller Edition': 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/8.jpg?v=1762553097',
      },

      // ─── PREORDER MATH MODEL FOR THIS PRODUCT ─────────────────────
      // No special flags needed. The Storefront GraphQL precision
      // path plus _readPreciseBarTotal's Strategy 3 (cart-effective
      // math from main_per_unit + Kaching's discountValue + rate)
      // produces the exact cart preorder bundle total in every
      // currency. See _readPreciseBarTotal for the rationale.
      // ──────────────────────────────────────────────────────────────
      preorderDiscount: {
        // Base (USD) — last-resort fallback when no localized prices
        // have loaded yet (network failure). Strategy 3 takes over
        // once /products/.js or GraphQL completes.
        default: { type: 'fixed', amount: 10 },
        double:  { type: 'fixed', amount: 20 },
      },
    },

    'luhxe-offer-1': {
      IDS: {
        Rose:     { 'Roller Edition': '45222451150895', Classic: '45222451118127' },
        Charcoal: { 'Roller Edition': '45222451216431', Classic: '45222451183663' },
        Snow:     { 'Roller Edition': '45222451281967', Classic: '45222451249199' },
      },
      preorderIDS: {
        Rose:     { 'Roller Edition': '45222453641263', Classic: '45222453608495' },
        Charcoal: { 'Roller Edition': '45222453706799', Classic: '45222453674031' },
        Snow:     { 'Roller Edition': '45222453772335', Classic: '45222453739567' },
      },
      SINGLE_ID: 'b68463a7-016d-4387-a56b-e436298a399c',
      DOUBLE_ID: '99211143-023c-4756-bf96-07b01324dc62',
      colorStock: {
        Rose:     'disabled',
        Charcoal: 'disabled',
        Snow:     'available',
      },
      preorderDiscount: {
        default: { type: 'fixed', amount: 10 },
        double:  { type: 'fixed', amount: 20 },
      },
    },

    'luhxe-travel-bag-2-0-international-womens-day': {
      IDS: {
        Rose:     { 'Roller Edition': '44981041496111', Classic: '44981041463343' },
        Charcoal: { 'Roller Edition': '44981041561647', Classic: '44981041528879' },
        Snow:     { 'Roller Edition': '44981041627183', Classic: '44981041594415' },
      },
      preorderIDS: {
        Rose:     { 'Roller Edition': '45029902155823', Classic: '45029902123055' },
        Charcoal: { 'Roller Edition': '45029902221359', Classic: '45029902188591' },
        Snow:     { 'Roller Edition': '45029902286895', Classic: '45029902254127' },
      },
      SINGLE_ID: '56907c76-c0be-44f8-8783-7b2a1a35c6f6',
      DOUBLE_ID: '80db50ae-0c70-4f50-83bb-095c42904585',
      colorStock: {
        Rose:     'disabled',
        Charcoal: 'disabled',
        Snow:     'available',
      },
      preorderDiscount: {
        default: { type: 'fixed', amount: 10 },
      },
    },

    'luhxe-travel-bag-2-0-easter-sale': {
      IDS: {
        Rose:     { 'Roller Edition': '45161435004975', Classic: '45161434972207' },
        Charcoal: { 'Roller Edition': '45161435070511', Classic: '45161435037743' },
        Snow:     { 'Roller Edition': '45161435136047', Classic: '45161435103279' },
      },
      preorderIDS: {
        Rose:     { 'Roller Edition': '45207121920047', Classic: '45207121887279' },
        Charcoal: { 'Roller Edition': '45207121985583', Classic: '45207121952815' },
        Snow:     { 'Roller Edition': '45207122051119', Classic: '45207122018351' },
      },
      SINGLE_ID: '9ca5e539-b6fa-4865-a8b6-a58ed3639ae2',
      DOUBLE_ID: '8dcba9f2-27fa-4cc6-859b-09d2930dad05',
      colorStock: {
        Rose:     'disabled',
        Charcoal: 'disabled',
        Snow:     'available',
      },
      preorderDiscount: {
        default: { type: 'fixed', amount: 10 },
      },
    },

    'luhxe-travel-bag-2-0-anti-tarriff-sale': {
      IDS: {
        Rose:     { 'Roller Edition': '43736914296879', Classic: '43736914264111' },
        Charcoal: { 'Roller Edition': '43736914362415', Classic: '43736914329647' },
        Snow:     { 'Roller Edition': '43736914427951', Classic: '43736914395183' },
      },
      preorderIDS: {
        Rose:     { 'Roller Edition': '45227857346607', Classic: '45227857313839' },
        Charcoal: { 'Roller Edition': '45227857412143', Classic: '45227857379375' },
        Snow:     { 'Roller Edition': '45227857477679', Classic: '45227857444911' },
      },
      SINGLE_ID: '104d0eca-04c0-42dd-89fc-ca8216d34c37',
      DOUBLE_ID: 'f8de9b70-2242-492b-b0c6-6f32c79b721c',
      colorStock: {
        Rose:     'disabled',
        Charcoal: 'disabled',
        Snow:     'available',
      },
      preorderDiscount: {
        default: { type: 'fixed', amount: 10 },
      },
    },

    'luhxe-travel-bag-2-0-mothers-day-sale': {
      IDS: {
        Rose:     { 'Roller Edition': '45237064400943', Classic: '45237064368175' },
        Charcoal: { 'Roller Edition': '45237064466479', Classic: '45237064433711' },
        Snow:     { 'Roller Edition': '45237064532015', Classic: '45237064499247' },
      },
      preorderIDS: {
        Rose:     { 'Roller Edition': '45323427315759', Classic: '45323427282991' },
        Charcoal: { 'Roller Edition': '45323427381295', Classic: '45323427348527' },
        Snow:     { 'Roller Edition': '45323427446831', Classic: '45323427414063' },
      },
      SINGLE_ID: '88930bf0-94d5-4088-b815-2df49a28b3fb',
      DOUBLE_ID: 'eb381e19-23ca-478a-83f9-27c5be41d292',
      colorStock: {
        Rose:     'disabled',
        Charcoal: 'disabled',
        Snow:     'available',
      },
      preorderDiscount: {
        default: { type: 'fixed', amount: 10 },
      },
    },
    'luhxe-travel-bag-2-0-memorial-day-sale': {
      IDS: {
        Rose:     { 'Roller Edition': '45237064400943', Classic: '45237064368175' },
        Charcoal: { 'Roller Edition': '45237064466479', Classic: '45237064433711' },
        Snow:     { 'Roller Edition': '45237064532015', Classic: '45237064499247' },
      },
      preorderIDS: {
        Rose:     { 'Roller Edition': '45323427315759', Classic: '45323427282991' },
        Charcoal: { 'Roller Edition': '45323427381295', Classic: '45323427348527' },
        Snow:     { 'Roller Edition': '45323427446831', Classic: '45323427414063' },
      },
      SINGLE_ID: '88930bf0-94d5-4088-b815-2df49a28b3fb',
      DOUBLE_ID: 'eb381e19-23ca-478a-83f9-27c5be41d292',
      colorStock: {
        Rose:     'disabled',
        Charcoal: 'disabled',
        Snow:     'available',
      },
      preorderDiscount: {
        default: { type: 'fixed', amount: 10 },
      },
    },

  },

  /* --------------------------------------------------------------------------
   * STATE
   * -------------------------------------------------------------------------- */
  state: {
    initialized: false,
    lastAddedItem: null,
    cartCount: 0,
    observersStarted: false,
    preorder: { mounted: false, currentState: 'none' },
    atc:      { enhanced: false, currentState: 'none', soldOut: false },
    sticky:   { mounted: false, visible: false, els: null, trigger: null, io: null, footerIo: null, scrollRaf: null },
  },

  dateConfig: {
    months: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
    useOrdinalSuffix: true,
    dateFormat: 'short',
  },

  /* --------------------------------------------------------------------------
   * PRODUCT RESOLUTION
   * -------------------------------------------------------------------------- */
  getProductHandle() {
    return window.location.pathname.split('/products/')[1]?.split('?')[0]?.split('/')[0] || '';
  },

  getProductConfig() {
    const handle = this.getProductHandle();
    return this.PRODUCTS[handle] || null;
  },

  /** True only for duplicate PDPs where GemPages/Kaching variant sync is broken. */
  usesBypassGemPagesAtc() {
    return !!this.getProductConfig()?.bypassGemPagesAtc;
  },

  getAtcButtonSelector() {
    if (this.usesBypassGemPagesAtc()) {
      return 'button.gp-button-atc';
    }
    return this.config.atcButton.selector;
  },

  /**
   * Resolve the pre-order product handle for the active product.
   *
   * Lookup priority:
   *   1. Per-product `preorderProductHandle` in PRODUCTS (rare — only
   *      use this when one product needs a different handle than the
   *      shared map).
   *   2. Centralized `config.preorderHandles` map keyed by main handle.
   *
   * Returns null when no handle is configured — the pre-order label
   * then falls back to rate-based math.
   */
  getPreorderHandle() {
    const cfg = this.getProductConfig();
    if (cfg?.preorderProductHandle) return cfg.preorderProductHandle;
    const handle = this.getProductHandle();
    return this.config.preorderHandles?.[handle] || null;
  },

  /**
   * Resolve the variant-option schema for the active product. Falls back to
   * the Luhxe-style Color + Model shape when a product doesn't define its
   * own schema.
   */
  getProductSchema() {
    const cfg = this.getProductConfig();
    if (!cfg || !cfg.schema) return this.DEFAULT_SCHEMA;
    return {
      ...this.DEFAULT_SCHEMA,
      ...cfg.schema,
      modelMap: { ...this.DEFAULT_SCHEMA.modelMap, ...(cfg.schema.modelMap || {}) },
    };
  },

  hasColorVariants() {
    return !!this.getProductSchema().colorOptionName;
  },

  /**
   * Convert the raw value seen in the DOM (Kaching `data-value` or Shopify
   * option input value) into the canonical model key used in IDS lookups
   * and offer-state branches. Unknown values pass through unchanged.
   */
  normalizeModelValue(raw) {
    if (!raw) return null;
    const schema = this.getProductSchema();
    return schema.modelMap?.[raw] || raw;
  },

  /**
   * Look up a variant ID for a (color, canonical model) pair. Handles two
   * IDS shapes:
   *   • Nested:  IDS[color][model]   — multi-color products
   *   • Flat:    IDS[model]           — single-axis products (no color)
   */
  lookupVariantId(idMap, color, canonicalModel) {
    if (!idMap || !canonicalModel) return null;
    if (color && idMap[color] && typeof idMap[color] === 'object') {
      return idMap[color][canonicalModel] || null;
    }
    // Flat lookup
    return idMap[canonicalModel] || null;
  },

  getColorStock() {
    const cfg = this.getProductConfig();
    if (!cfg) return {};
    if (cfg.colorStock) return cfg.colorStock;
    if (this.hasColorVariants()) {
      return { Rose: 'available', Charcoal: 'available', Snow: 'available' };
    }
    return {};
  },

  getDaysUntilShip() {
    return this.getProductConfig()?.daysUntilShip ?? this.config.daysUntilShip;
  },

  /* --------------------------------------------------------------------------
   * INIT
   * -------------------------------------------------------------------------- */
  init(customConfig = {}) {
    this.config = { ...this.config, ...customConfig };

    // ─── Locale ────────────────────────────────────────────────────────
    // Swap the two config-level strings that are customer-facing to the
    // active language, unless the caller explicitly passed its own value.
    const locale = this.getLocale();
    if (locale !== 'en') {
      if (customConfig.propertyKey === undefined) {
        this.config.propertyKey = this.t('propertyKey');
      }
      if (customConfig.kaching === undefined) {
        this.config.kaching = {
          ...this.config.kaching,
          preorderLabelPrefix: this.t('preorderLabelPrefix'),
        };
      }
    }

    // No entry for this handle → stay inert. No buttons, no observers, nothing.
    const handle = this.getProductHandle();
    if (!this.PRODUCTS[handle]) {
      if (this.config.debug) {
        console.log('PreorderManager skipped — no product config for handle:', handle || '(none)');
      }
      return this;
    }

    this.state.initialized = true;
    if (this.config.debug) {
      console.log('PreorderManager initialized, handle =', handle, '| locale =', locale);
    }

    // One-time cleanup: invalidate stale probe-rate and REST-precision
    // cache entries left over from earlier strategies. Storefront GraphQL
    // is the precision source of truth now; carrying older cached values
    // forward would mask the new path.
    try {
      const keysToRemove = [];
      for (let i = 0; i < sessionStorage.length; i++) {
        const k = sessionStorage.key(i);
        if (k && (k.startsWith('pm:probe:') || k.startsWith('pm:lp:') || k.startsWith('pm:gqlv:'))) keysToRemove.push(k);
      }
      keysToRemove.forEach(k => sessionStorage.removeItem(k));
      if (this.config.debug && keysToRemove.length) {
        console.log('[PreorderManager] cleared', keysToRemove.length, 'stale cache entries');
      }
    } catch (_) {}

    // Fetch localized variant prices from JSON-LD on the main + preorder
    // product pages. These give us cart-accurate numbers without any rate
    // math. Fire-and-forget; the UI re-renders once data arrives, and any
    // path that runs before then uses the discount-math fallback.
    // Cached in sessionStorage so subsequent loads in the same session
    // skip the network entirely.
    this._ensureLocalizedPrices().then((data) => {
      if (!data) return;
      try { this.updatePreorderButtonState(); }      catch (_) {}
      try { this.updateKachingBarPreorderLabels(); } catch (_) {}
      try { this.updateStickyUI(); }                 catch (_) {}
    });

    // Probe fetch — independent of localized prices; only used by products
    // opting in with `useProbeRateDiscount: true`. Re-render once the
    // rate arrives so the bar label switches off the rate-math fallback.
    this._ensureProbeRate().then((entry) => {
      if (!entry) return;
      try { this.updatePreorderButtonState(); }      catch (_) {}
      try { this.updateKachingBarPreorderLabels(); } catch (_) {}
      try { this.updateStickyUI(); }                 catch (_) {}
    });

    if (this.config.preorderButton?.enabled && !this.config.disablePreorder) {
      this.bootstrapPreorderButton().catch(err => {
        if (this.config.debug) console.warn('Preorder bootstrap failed:', err);
      });
    }
    if (this.config.atcButton?.enabled) {
      this.bootstrapAtcButton().catch(err => {
        if (this.config.debug) console.warn('ATC bootstrap failed:', err);
      });
    }
    if (this.config.stickyAtc?.enabled) {
      this.bootstrapStickyAtc().catch(err => {
        if (this.config.debug) console.warn('Sticky ATC bootstrap failed:', err);
      });
    }
    return this;
  },

  updateConfig(newConfig)         { this.config = { ...this.config, ...newConfig }; return this; },
  updateDateConfig(newDateConfig) { this.dateConfig = { ...this.dateConfig, ...newDateConfig }; return this; },

  waitForSelector(selector, timeout = null) {
    const waitTimeout = timeout || this.config.waitTimeout;
    return new Promise((resolve, reject) => {
      const el = document.querySelector(selector);
      if (el) return resolve(el);
      const observer = new MutationObserver((_, obs) => {
        const e = document.querySelector(selector);
        if (e) { obs.disconnect(); resolve(e); }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => { observer.disconnect(); reject(new Error(`Timeout: ${selector}`)); }, waitTimeout);
    });
  },

  delay(ms) { return new Promise(r => setTimeout(r, ms)); },

  /* --------------------------------------------------------------------------
   * CURRENCY-AGNOSTIC PRICE READING & DISCOUNTING
   * -------------------------------------------------------------------------- */

  _firstByAny(parent, selectors) {
    if (!parent) return null;
    for (const sel of selectors) {
      try {
        const el = parent.querySelector(sel);
        if (el && (el.textContent || '').trim()) return el;
      } catch (_) {}
    }
    return null;
  },

  /**
   * Reads the current Kaching bar's displayed prices in whatever currency the
   * storefront is using. Returns { sale, compare, saleBase, compareBase }.
   * saleBase / compareBase carry the base-currency originals when the page
   * exposes them via the configured attribute (e.g. data-vitals-cc-usd).
   */
  readKachingPrices(bar = null) {
    const target = bar || document.querySelector(this.config.kaching.selectedBarSelector);
    if (!target) return { sale: '', compare: '', saleBase: '', compareBase: '' };

    const saleEl    = this._firstByAny(target, this.config.kaching.salePriceSelectors);
    const compareEl = this._firstByAny(target, this.config.kaching.comparePriceSelectors);

    const cleanText = (el) => {
      if (!el) return '';
      const clone = el.cloneNode(true);
      // Strip nodes that aren't part of the live sale price — including our
      // OWN injected pre-order label, in case the fallback selector matched
      // the price container as a whole.
      clone.querySelectorAll('del, s, .kaching-bundles__bar-price-compare, .kaching-bundles__bar-price-was, .cm-kaching-preorder-label')
        .forEach(n => n.remove());
      return (clone.textContent || '').trim().replace(/\s+/g, ' ');
    };

    const attr = this.config.kaching.baseCurrencyAttr;
    const baseCcy = (el) => {
      if (!el || !attr) return '';
      const own = el.getAttribute?.(attr);
      if (own) return own;
      const child = el.querySelector?.(`[${attr}]`);
      return child ? child.getAttribute(attr) : '';
    };

    return {
      sale:        cleanText(saleEl),
      compare:     cleanText(compareEl),
      saleBase:    baseCcy(saleEl),
      compareBase: baseCcy(compareEl),
    };
  },

  parsePriceToNumber(str) {
    if (!str) return NaN;
    const match = String(str).match(/[\d][\d.,\s]*/);
    if (!match) return NaN;
    let cleaned = match[0].replace(/\s/g, '');

    const hasDot   = cleaned.includes('.');
    const hasComma = cleaned.includes(',');

    if (hasDot && hasComma) {
      if (cleaned.lastIndexOf('.') > cleaned.lastIndexOf(',')) {
        cleaned = cleaned.replace(/,/g, '');
      } else {
        cleaned = cleaned.replace(/\./g, '').replace(',', '.');
      }
    } else if (hasComma && !hasDot) {
      const parts = cleaned.split(',');
      const afterLast = parts[parts.length - 1];
      if (parts.length === 2 && afterLast.length <= 2) {
        cleaned = cleaned.replace(',', '.');
      } else {
        cleaned = cleaned.replace(/,/g, '');
      }
    } else if (hasDot) {
      const parts = cleaned.split('.');
      const afterLast = parts[parts.length - 1];
      if (!(parts.length === 2 && afterLast.length <= 2)) {
        cleaned = cleaned.replace(/\./g, '');
      }
    }

    const n = parseFloat(cleaned);
    return isNaN(n) ? NaN : n;
  },

  /**
   * Final-step rounding for preorder display values.
   *
   * JS's toFixed(2) rounds half-up: 271.245 → "271.25". Shopify cart
   * truncates (floors) fractional cents: same 271.245 → 271.24. The
   * difference shows up in markets where rate-converted variant prices
   * (or Kaching's internal per-unit discount × rate) leave a residual
   * half-cent — the bar's preorder label can read 1¢ higher than what
   * cart will actually charge.
   *
   * Products that opt in with `floorPreorderDisplay: true` get their
   * computed preorder number floored to 2 decimals here before the
   * string formatter sees it.
   */
  _finalizePreorderNumber(num) {
    if (isNaN(num)) return num;
    const cfg = this.getProductConfig();
    if (cfg?.floorPreorderDisplay) {
      return Math.floor(num * 100) / 100;
    }
    return num;
  },

  replacePriceNumber(priceStr, newNum) {
    if (!priceStr || isNaN(newNum)) return priceStr;
    const match = priceStr.match(/[\d][\d.,\s]*/);
    if (!match) return priceStr;

    const originalNumStr = match[0];
    const trimmed        = originalNumStr.replace(/\s/g, '');
    const hasDot         = trimmed.includes('.');
    const hasComma       = trimmed.includes(',');

    let decimalSep  = '.';
    let thousandSep = '';
    let decimals    = 0;

    if (hasDot && hasComma) {
      if (trimmed.lastIndexOf('.') > trimmed.lastIndexOf(',')) {
        decimalSep = '.'; thousandSep = ',';
      } else {
        decimalSep = ','; thousandSep = '.';
      }
      const decMatch = trimmed.match(/[.,](\d+)$/);
      decimals = decMatch ? decMatch[1].length : 0;
    } else if (hasComma && !hasDot) {
      const parts = trimmed.split(',');
      const afterLast = parts[parts.length - 1];
      if (parts.length === 2 && afterLast.length <= 2) {
        decimalSep = ','; decimals = afterLast.length;
      } else {
        thousandSep = ',';
      }
    } else if (hasDot) {
      const parts = trimmed.split('.');
      const afterLast = parts[parts.length - 1];
      if (parts.length === 2 && afterLast.length <= 2) {
        decimals = afterLast.length;
      } else {
        thousandSep = '.';
      }
    }

    const safeNum = Math.max(0, newNum);
    let formatted = decimals > 0 ? safeNum.toFixed(decimals) : String(Math.round(safeNum));

    if (decimalSep !== '.' && formatted.includes('.')) {
      formatted = formatted.replace('.', decimalSep);
    }
    if (thousandSep) {
      const parts = formatted.split(decimalSep);
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);
      formatted = parts.join(decimalSep);
    }

    return priceStr.replace(originalNumStr, formatted);
  },

  /**
   * Derive the store's base→display exchange rate. Tries in order:
   *   1. window.Shopify.currency.rate (Shopify Markets)
   *   2. data-vitals-cc-usd elements anywhere on the page (Vitals CC)
   *   3. Fallback rate of 1 (USD-only store, or converter not loaded yet)
   */
  getCurrencyRate() {
    const now = Date.now();
    const cache = this.state._rateCache;
    if (cache && (now - cache.at) < 30000) return cache.rate;

    let rate = 1;
    let source = null;

    try {
      const s = window.Shopify;
      if (s && s.currency && typeof s.currency.rate !== 'undefined') {
        const r = parseFloat(s.currency.rate);
        if (!isNaN(r) && r > 0) {
          rate = r;
          source = `Shopify.currency.rate (${s.currency.active || '?'} @ ${r})`;
        }
      }
    } catch (_) { /* ignore */ }

    if (!source) {
      const attr = this.config.kaching.baseCurrencyAttr;
      if (attr) {
        const candidates = document.querySelectorAll(`[${attr}]`);
        for (const el of candidates) {
          const baseText    = el.getAttribute(attr);
          const displayText = (el.textContent || '').trim();
          if (!baseText || !displayText) continue;

          const baseNum    = this.parsePriceToNumber(baseText);
          const displayNum = this.parsePriceToNumber(displayText);
          if (isNaN(baseNum) || isNaN(displayNum) || baseNum <= 0 || displayNum <= 0) continue;

          rate = displayNum / baseNum;
          source = `${attr} (${baseText} → ${displayText})`;
          break;
        }
      }
    }

    if (this.config.debug) {
      if (source) {
        console.log('[PreorderManager] currency rate =', +rate.toFixed(6), 'from', source);
      } else {
        console.log('[PreorderManager] no currency source found — rate=1 (assumes prices are in base currency)');
      }
    }

    this.state._rateCache = source ? { at: now, rate } : null;
    return rate;
  },

  /**
   * Subtract a discount from a localized price.
   * @param {string} priceStr     - Displayed price ("LE 9,455.93", "$179", "€169,00")
   * @param {object} discount     - { type: 'fixed'|'percent', amount: number }
   * @param {string} basePriceStr - Optional same-element base-currency price.
   *                                When supplied we derive the conversion rate
   *                                locally for maximum accuracy.
   */
  /**
   * Resolve the base→display exchange rate to use for a specific price
   * element. Tries in order:
   *   1. Shopify.currency.rate — the UNROUNDED rate Shopify stores
   *      internally. Best because rates derived from displayed prices lose
   *      precision to the display-rounding (e.g. $129 × 1.40336 = $181.03
   *      rounded to $181, giving a derived rate of 1.4031 instead of the
   *      true 1.40336).
   *   2. Per-element base/display pair — accurate enough but limited by
   *      display rounding.
   *   3. Page-wide scan from getCurrencyRate().
   *
   * @returns {{rate: number|null, source: string|null}}
   */
  _resolveRate(basePriceStr, displayNum) {
    try {
      const r = parseFloat(window.Shopify?.currency?.rate);
      if (!isNaN(r) && r > 0) {
        return { rate: r, source: 'shopify-currency-rate' };
      }
    } catch (_) {}

    if (basePriceStr) {
      const baseNum = this.parsePriceToNumber(basePriceStr);
      if (!isNaN(baseNum) && baseNum > 0 && displayNum > 0) {
        return { rate: displayNum / baseNum, source: 'per-element' };
      }
    }

    const pageRate = this.getCurrencyRate();
    if (this.state._rateCache) {
      return { rate: pageRate, source: 'page' };
    }

    return { rate: null, source: null };
  },

  /**
   * Subtract a discount from a localized price.
   *
   * @param {string} priceStr     - Displayed price ("$181.00", "€169,00")
   * @param {object} discount     - { type: 'fixed'|'percent', amount: number }
   * @param {string} basePriceStr - Optional base-currency price for the same
   *                                element (e.g. "$179" from data-vitals-cc-usd).
   *                                When available, we walk the math FORWARD
   *                                (preorder_base × rate) instead of subtracting
   *                                from the rounded display — this matches what
   *                                Shopify's cart calculates to the cent.
   */
  applyDiscountToPrice(priceStr, discount, basePriceStr = '') {
    if (!priceStr || !discount) return priceStr;
    const num = this.parsePriceToNumber(priceStr);
    if (isNaN(num)) return priceStr;

    let newNum;
    if (discount._localized) {
      // Amount is ALREADY in display currency (came from a per-currency
      // override in the config). Apply as-is, no rate math.
      if (discount.type === 'percent') {
        newNum = num * (1 - (discount.amount || 0) / 100);
      } else {
        newNum = num - (discount.amount || 0);
      }
      if (this.config.debug) {
        console.log('[PreorderManager] localized discount applied (no rate conversion):', {
          priceStr, type: discount.type, amount: discount.amount,
          result: +newNum.toFixed(4),
        });
      }
    } else if (discount.type === 'percent') {
      // Percent discounts are currency-agnostic — no conversion needed.
      newNum = num * (1 - (discount.amount || 0) / 100);
    } else {
      // 'fixed' discount in BASE currency. Need a rate to convert.
      const { rate, source } = this._resolveRate(basePriceStr, num);

      if (rate === null) {
        // No rate source. If we're definitely in a non-base currency,
        // returning a rate=1 result would subtract a USD amount from a
        // non-USD price — wrong. Bail out and leave the sale price.
        const active = (() => {
          try { return String(window.Shopify?.currency?.active || '').toUpperCase(); }
          catch (_) { return ''; }
        })();
        if (active && active !== 'USD') {
          if (this.config.debug) {
            console.warn('[PreorderManager] no currency rate available in', active,
                         '— skipping fixed discount on', priceStr);
          }
          return priceStr;
        }
        // USD-only store (or no active currency info) → safe to skip conversion.
        newNum = num - (discount.amount || 0);
      } else {
        // Forward path when we know the base price (cart-accurate):
        //   preorder_base    = sale_base - discount
        //   preorder_display = preorder_base × rate
        //
        // Backward path otherwise (less accurate by up to one rounding unit
        // per variant — accumulates on multi-variant bundle bars):
        //   preorder_display = sale_display - discount × rate
        let usedForward = false;
        if (basePriceStr) {
          const baseNum = this.parsePriceToNumber(basePriceStr);
          if (!isNaN(baseNum) && baseNum > 0) {
            const preorderBase = baseNum - (discount.amount || 0);
            newNum = preorderBase * rate;
            usedForward = true;
          }
        }
        if (!usedForward) {
          newNum = num - (discount.amount || 0) * rate;
        }

        if (this.config.debug) {
          console.log('[PreorderManager] discount conversion:', {
            priceStr, basePriceStr,
            rate: +rate.toFixed(6), rateSource: source,
            method: usedForward ? 'forward (base × rate)' : 'backward (display − discount × rate)',
            discountBase: discount.amount,
            result: +newNum.toFixed(4),
          });
        }
      }
    }

    return this.replacePriceNumber(priceStr, this._finalizePreorderNumber(newNum));
  },

  /**
   * Fetch the product's base-currency variant prices from the Shopify JSON
   * endpoint. Used only for debug logging / sanity checks now — pre-order
   * runs in every currency.
   */
  async _loadProductData() {
    const handle = this.getProductHandle();
    if (!handle) return;

    try {
      const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
      if (!res.ok) return;
      const product = await res.json();

      const prices = [];
      for (const v of (product.variants || [])) {
        if (v.price != null) {
          const p = parseFloat(v.price);
          if (!isNaN(p)) prices.push(p / 100);
        }
        if (v.compare_at_price != null) {
          const p = parseFloat(v.compare_at_price);
          if (!isNaN(p)) prices.push(p / 100);
        }
      }
      const usdPrices = prices.filter(p => p > 0);
      if (!usdPrices.length) return;

      this.state._productData = { handle, usdPrices };

      if (this.config.debug) {
        console.log('[PreorderManager] fetched base prices for', handle + ':',
                    `min=${Math.min(...usdPrices)} max=${Math.max(...usdPrices)}`);
      }

      // Re-render now that we have data.
      try { await this.ensurePreorderButton(); } catch (_) {}
      try { this.updatePreorderButtonState(); } catch (_) {}
      try { this.updateKachingBarPreorderLabels(); } catch (_) {}
    } catch (_) { /* swallow */ }
  },

  /**
   * Detect whether the storefront is displaying prices in the store's BASE
   * currency (USD). Kept around for debug logging only — pre-order now runs
   * in every currency.
   */
  isDisplayingUSD() {
    try {
      const active = window.Shopify?.currency?.active;
      if (active && String(active).toUpperCase() !== 'USD') return false;
    } catch (_) {}

    const data = this.state._productData;
    if (data?.usdPrices?.length) {
      const { sale } = this.readKachingPrices();
      const displayNum = this.parsePriceToNumber(sale);
      if (!isNaN(displayNum) && displayNum > 0) {
        const minUsd = Math.min(...data.usdPrices);
        const maxUsd = Math.max(...data.usdPrices);
        const plausibleLo = minUsd * 0.4;
        const plausibleHi = maxUsd * 2.5;
        return displayNum >= plausibleLo && displayNum <= plausibleHi;
      }
    }
    return true;
  },

  /**
   * Pick a discount entry from a map keyed by state names.
   *   1. Exact state ('double_mixed', 'single_classic', …)
   *   2. Prefix match on 'single'/'double'
   *   3. 'default' fallback
   * Returns null if no match.
   */
  _pickFromDiscountMap(map, state) {
    if (!map) return null;
    if (map[state]) return map[state];
    if (state) {
      const prefix = state.split('_')[0];
      if (map[prefix]) return map[prefix];
    }
    return map.default || null;
  },

  /**
   * Per-currency discount override. Returns null when no override is
   * defined for the active currency. The returned discount carries
   * `_localized: true` so applyDiscountToPrice applies it as-is with
   * no rate conversion (amount is already in display currency).
   *
   * Used when Kaching's main/preorder bundle deals don't share a
   * discount structure that the exact path can recover for a given
   * market — e.g. The Black Bag in CAD.
   */
  _resolvePerCurrencyPreorderDiscount(state) {
    const map = this.getProductConfig()?.preorderDiscount;
    if (!map) return null;
    try {
      const active = String(window.Shopify?.currency?.active || '').toUpperCase();
      if (active && map[active] && typeof map[active] === 'object') {
        const resolved = this._pickFromDiscountMap(map[active], state);
        if (resolved) {
          return { ...resolved, _localized: true };
        }
      }
    } catch (_) {}
    return null;
  },

  /**
   * Base-currency (USD) discount. Used as the final fallback when the
   * exact path is unavailable AND no per-currency override matches.
   * applyDiscountToPrice will rate-convert via Shopify.currency.rate.
   */
  _resolveBasePreorderDiscount(state) {
    return this._pickFromDiscountMap(this.getProductConfig()?.preorderDiscount, state);
  },

  /**
   * Backwards-compatible combined lookup: per-currency first, then base.
   * Most call sites should prefer the two specific helpers above so they
   * can interleave the exact path between them.
   */
  resolvePreorderDiscount(state) {
    return this._resolvePerCurrencyPreorderDiscount(state)
        || this._resolveBasePreorderDiscount(state);
  },

  /* --------------------------------------------------------------------------
   * EXACT LOCALIZED PRICE FETCHING (option 3 — cart-accurate to the cent)
   * --------------------------------------------------------------------------
   * Pulls variant prices straight from /products/{handle}.js. Shopify
   * Markets localizes this endpoint to the storefront's active currency,
   * so the prices returned are EXACTLY what the cart will use for each
   * line — no rate math, no JSON-LD parsing, no HTML to scrape.
   *
   * The discount we subtract from a Kaching bar's sale is then:
   *
   *   Σ (main_localized[variant] − preorder_localized[variant]) × qty_in_bar
   *
   * which equals the discount cart actually applies (Kaching's bundle
   * discount cancels out because it hits both variants equally).
   * -------------------------------------------------------------------------- */

  /**
   * Read the Storefront API access token and market country from the
   * Kaching app block in the DOM. Returns null when the block isn't
   * present (e.g. product page without Kaching). The token is a
   * public-storefront credential — same one the Kaching app uses on
   * this page to fetch its own product data — so reading it here
   * doesn't expand any trust surface.
   */
  _getKachingMarketContext() {
    if (this.state._kachingMarketCtx !== undefined) return this.state._kachingMarketCtx;
    let ctx = null;
    try {
      const el = document.querySelector('kaching-bundles-block[config]');
      if (el) {
        const raw = el.getAttribute('config');
        const parsed = JSON.parse(raw);
        if (parsed?.storefrontAccessToken && parsed?.country) {
          ctx = {
            token:    parsed.storefrontAccessToken,
            country:  String(parsed.country).toUpperCase(),
            currency: parsed.marketCurrencyCode || null,
            rate:     parsed.currencyRate || null,
          };
        }
      }
    } catch (_) { /* swallow */ }
    this.state._kachingMarketCtx = ctx;
    if (this.config.debug && ctx) {
      console.log('[PreorderManager] kaching market context:', ctx);
    }
    return ctx;
  },

  /**
   * Fetch variant prices via Shopify Storefront GraphQL with
   * `@inContext(country: …)` for the active market.
   *
   * Why GraphQL instead of /products/.js: the REST endpoint returns
   * prices as integer cents, losing any sub-cent precision Shopify
   * Markets stores internally for rate-converted prices. GraphQL's
   * Money.amount is a decimal string that preserves whatever
   * precision is on the underlying record (e.g. "202.995"). That
   * sub-cent piece is what made cart and the bar label diverge in
   * NZD/GBP — they both did the same math, but cart had full
   * precision and the script saw a rounded $203 from REST.
   *
   * Returns { prices, options } in the same shape as the REST
   * fetcher so it's a drop-in upgrade. Returns null on any failure
   * (missing token, network error, GraphQL errors, no variants);
   * callers fall back to REST in that case.
   */
  /**
   * Fetch variant prices via Storefront GraphQL by VARIANT IDs (no
   * product handle needed). Uses the `nodes(ids: …)` query to pull a
   * batch of variants in one round-trip.
   *
   * Why this exists separately from the handle-based fetcher: when
   * a product config has `preorderIDS` filled in but no entry in
   * `preorderHandles` (and no `preorderProductHandle`), we still
   * have everything we need to look up the localized preorder
   * prices — we just don't have the handle. This path uses what we
   * do have.
   *
   * Same return shape as the handle fetcher: { prices, options }.
   * Returns null on any failure so callers fall through.
   *
   * `idMap` is the product config's preorderIDS structure:
   *   { Color1: { Model1: '12345', Model2: '67890' }, … }
   * or for non-color products:
   *   { Model1: '12345', … }
   * The function walks the structure to collect all variant IDs and
   * preserves the option labels so downstream lookups still work.
   */
  async _fetchPreciseVariantPricesByVariantIds(idMap) {
    if (!idMap) return null;
    const ctx = this._getKachingMarketContext();
    if (!ctx?.token || !ctx?.country) return null;
    const country = ctx.country.replace(/[^A-Z]/g, '').slice(0, 2);
    if (country.length !== 2) return null;

    // Walk the idMap and collect { variantId, optionPath } pairs.
    // optionPath is the array of option values that led here, used
    // to reconstruct lookup keys after the fetch.
    const collected = [];
    const walk = (node, path) => {
      if (node == null) return;
      if (typeof node === 'string' || typeof node === 'number') {
        collected.push({ variantId: String(node), optionPath: [...path] });
        return;
      }
      if (typeof node === 'object') {
        for (const [k, v] of Object.entries(node)) {
          walk(v, [...path, k]);
        }
      }
    };
    walk(idMap, []);
    if (!collected.length) return null;

    const numericIds = collected.map(c => c.variantId);
    const cacheKey = `pm:gqlv:${ctx.country}:${numericIds.sort().join(',')}`;
    try {
      const cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        const parsed = JSON.parse(cached);
        if (parsed?.prices && parsed?.options) {
          if (this.config.debug) {
            console.log('[PreorderManager] GraphQL variant-id cache hit:', ctx.country, parsed);
          }
          return parsed;
        }
      }
    } catch (_) {}

    const gids = collected.map(c => `gid://shopify/ProductVariant/${c.variantId}`);
    const query = `
      query VariantsById($ids: [ID!]!) @inContext(country: ${country}) {
        nodes(ids: $ids) {
          ... on ProductVariant {
            id
            title
            selectedOptions { name value }
            price { amount currencyCode }
          }
        }
      }
    `;

    try {
      const res = await fetch('/api/2024-01/graphql.json', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Shopify-Storefront-Access-Token': ctx.token,
        },
        body: JSON.stringify({ query, variables: { ids: gids } }),
      });
      if (!res.ok) {
        if (this.config.debug) {
          console.warn('[PreorderManager] GraphQL variant-id fetch failed HTTP', res.status);
        }
        return null;
      }
      const json = await res.json();
      if (json.errors?.length) {
        if (this.config.debug) {
          console.warn('[PreorderManager] GraphQL variant-id errors:', json.errors);
        }
        return null;
      }
      const nodes = json?.data?.nodes || [];
      if (!nodes.length) return null;

      const prices  = {};
      const options = {};
      for (const node of nodes) {
        if (!node?.id || !node?.price?.amount) continue;
        const numericId = String(node.id).split('/').pop();
        const amount = parseFloat(node.price.amount);
        if (!Number.isFinite(amount)) continue;
        prices[numericId] = amount;

        const optMap = {};
        for (const opt of (node.selectedOptions || [])) {
          if (opt?.name && opt?.value != null) optMap[opt.name] = opt.value;
        }
        const o1 = optMap['Color']   ?? optMap['color']   ?? null;
        const o2 = optMap['Model']   ?? optMap['model']   ?? null;
        const o3 = optMap['Variant'] ?? optMap['variant'] ?? null;
        const keys = [];
        if (o1 && o2 && o3) keys.push(`${o1}|${o2}|${o3}`);
        if (o1 && o2)       keys.push(`${o1}|${o2}`);
        if (o3)             keys.push(o3);
        if (o2)             keys.push(o2);
        if (o1)             keys.push(o1);
        for (const k of keys) if (!options[k]) options[k] = numericId;
      }

      // Bail if the GraphQL response was empty for the requested IDs
      // (typical when the variants belong to an unpublished product or
      // are unavailable in this country). Falling through to REST is
      // useless here too — REST needs a handle — so we surface null.
      if (!Object.keys(prices).length) return null;

      const result = { prices, options, _source: 'graphql-variant-ids' };
      try { sessionStorage.setItem(cacheKey, JSON.stringify(result)); } catch (_) {}
      if (this.config.debug) {
        console.log('[PreorderManager] GraphQL precise prices by variant IDs:',
          { country: ctx.country, requested: numericIds.length, returned: Object.keys(prices).length, result });
      }
      return result;
    } catch (err) {
      if (this.config.debug) console.warn('[PreorderManager] GraphQL variant-id error:', err);
      return null;
    }
  },

  async _fetchPreciseVariantPricesByHandle(handle) {
    if (!handle) return null;
    const ctx = this._getKachingMarketContext();
    if (!ctx?.token || !ctx?.country) return null;

    const cacheKey = `pm:gqlp:${handle}:${ctx.country}`;
    try {
      const cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        const parsed = JSON.parse(cached);
        if (parsed?.prices && parsed?.options) {
          if (this.config.debug) {
            console.log('[PreorderManager] GraphQL prices cache hit:', handle, ctx.country, parsed);
          }
          return parsed;
        }
      }
    } catch (_) { /* fall through */ }

    // CountryCode in @inContext is an enum, not a string — has to be
    // interpolated into the query rather than passed as a variable.
    // The country value comes from Kaching's parsed config (we
    // sanitize to 2 uppercase letters to avoid injection).
    const country = ctx.country.replace(/[^A-Z]/g, '').slice(0, 2);
    if (country.length !== 2) {
      if (this.config.debug) console.warn('[PreorderManager] invalid country for GraphQL:', ctx.country);
      return null;
    }

    const query = `
      query PreciseVariantPrices($handle: String!) @inContext(country: ${country}) {
        product(handle: $handle) {
          id
          handle
          variants(first: 50) {
            edges {
              node {
                id
                title
                selectedOptions { name value }
                price { amount currencyCode }
              }
            }
          }
        }
      }
    `;

    try {
      const res = await fetch('/api/2024-01/graphql.json', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Shopify-Storefront-Access-Token': ctx.token,
        },
        body: JSON.stringify({ query, variables: { handle } }),
      });
      if (!res.ok) {
        if (this.config.debug) {
          console.warn('[PreorderManager] GraphQL fetch failed for', handle, 'HTTP', res.status);
        }
        return null;
      }
      const json = await res.json();
      if (json.errors?.length) {
        if (this.config.debug) {
          console.warn('[PreorderManager] GraphQL errors for', handle, json.errors);
        }
        return null;
      }
      const edges = json?.data?.product?.variants?.edges || [];
      if (!edges.length) return null;

      // Build {prices, options} in the same shape _fetchLocalizedPricesByHandle returns.
      // GraphQL doesn't give us option1/option2/option3 as named keys, so
      // we synthesize the same keys from selectedOptions to keep
      // downstream lookup logic untouched.
      const prices  = {};
      const options = {};
      for (const { node } of edges) {
        if (!node?.id || !node?.price?.amount) continue;
        const numericId = String(node.id).split('/').pop();
        // GraphQL Money.amount is a decimal string like "202.995" — parse
        // it directly to preserve sub-cent precision. NEVER round here.
        const amount = parseFloat(node.price.amount);
        if (!Number.isFinite(amount)) continue;
        prices[numericId] = amount;

        const optMap = {};
        for (const opt of (node.selectedOptions || [])) {
          if (opt?.name && opt?.value != null) optMap[opt.name] = opt.value;
        }
        const o1 = optMap['Color']   ?? optMap['color']   ?? null;
        const o2 = optMap['Model']   ?? optMap['model']   ?? null;
        const o3 = optMap['Variant'] ?? optMap['variant'] ?? null;
        const keys = [];
        if (o1 && o2 && o3) keys.push(`${o1}|${o2}|${o3}`);
        if (o1 && o2)       keys.push(`${o1}|${o2}`);
        if (o3)             keys.push(o3);
        if (o2)             keys.push(o2);
        if (o1)             keys.push(o1);
        for (const k of keys) if (!options[k]) options[k] = numericId;
      }

      const result = { prices, options, _source: 'graphql' };
      try { sessionStorage.setItem(cacheKey, JSON.stringify(result)); } catch (_) {}
      if (this.config.debug) {
        console.log('[PreorderManager] GraphQL precise prices for', handle + ':', result);
      }
      return result;
    } catch (err) {
      if (this.config.debug) console.warn('[PreorderManager] GraphQL fetch error:', err);
      return null;
    }
  },

  async _fetchLocalizedPricesByHandle(handle) {
    if (!handle) return null;

    // Cache lookup — keyed by handle + active currency so a currency
    // switch in the same session triggers a fresh fetch.
    const currency = (() => {
      try { return String(window.Shopify?.currency?.active || 'XXX').toUpperCase(); }
      catch (_) { return 'XXX'; }
    })();
    const cacheKey = `pm:lp:${handle}:${currency}`;

    try {
      const cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        const parsed = JSON.parse(cached);
        // Cached object shape is { prices, options }. Reject anything else
        // (older versions cached just a flat price map) so it re-fetches
        // in the new shape.
        if (parsed?.prices && parsed?.options && Object.keys(parsed.prices).length) {
          if (this.config.debug) {
            console.log('[PreorderManager] cache hit:', handle, currency, parsed);
          }
          return parsed;
        }
      }
    } catch (_) { /* storage disabled / parse error — fall through to fetch */ }

    try {
      const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
      });
      if (!res.ok) {
        if (this.config.debug) {
          console.warn('[PreorderManager] .js fetch failed for', handle, 'HTTP', res.status);
        }
        return null;
      }
      const product = await res.json();
      if (!product?.variants?.length) {
        if (this.config.debug) {
          console.warn('[PreorderManager] .js had no variants for', handle);
        }
        return null;
      }

      // Build two parallel maps:
      //   prices  — variantId → localized price (in major units, e.g. 102.95)
      //   options — Shopify-raw option value(s) → variantId
      //
      // The options map lets the script find the right variant ID for the
      // CURRENT product even if config.IDS holds IDs from a different
      // product (e.g. duplicate landing pages with separate Shopify
      // products sharing the same Color × Model structure).
      //
      // Key format mirrors the schema Kaching shows in its DOM, using the
      // RAW option1/option2 values that match `data-value` in Kaching's
      // variant blocks (not the canonical normalized names).
      const prices  = {};
      const options = {};
      for (const v of product.variants) {
        if (v.id == null || v.price == null) continue;
        const cents = parseFloat(v.price);
        if (isNaN(cents)) continue;
        const id = String(v.id);
        prices[id] = cents / 100;

        const keys = [];
        if (v.option1 && v.option2 && v.option3) {
          keys.push(`${v.option1}|${v.option2}|${v.option3}`);
        }
        if (v.option1 && v.option2) {
          keys.push(`${v.option1}|${v.option2}`);
        }
        if (v.option1) {
          keys.push(v.option1);
        }
        for (const k of keys) {
          if (k && options[k] == null) options[k] = id;
        }
      }

      if (!Object.keys(prices).length) return null;
      const result = { prices, options };

      if (this.config.debug) {
        console.log('[PreorderManager] localized data for', handle, '(', currency, '):', result);
      }

      try { sessionStorage.setItem(cacheKey, JSON.stringify(result)); }
      catch (_) { /* quota or disabled — ignore */ }

      return result;
    } catch (e) {
      if (this.config.debug) console.warn('[PreorderManager] fetch error for', handle, e);
      return null;
    }
  },

  /**
   * PROBE-RATE PATH
   *
   * Fetches a known-USD product (configured at config.priceProbe) in the
   * active currency, then derives a conversion rate as:
   *
   *     rate = probe_localized_price / probe_usd_value
   *
   * Per-product `useProbeRateDiscount: true` then computes the preorder
   * discount as `rate × preorderDiscount.amount` (where amount is in
   * USD). The probe's localized price comes from /products/{handle}.js,
   * which exposes 2-decimal precision — same as variant prices — but
   * captures cart's effective conversion factor including any custom
   * Markets rounding rules.
   *
   * Result is cached in sessionStorage keyed by handle + currency so
   * a single fetch per session per currency suffices. Falls back to
   * Shopify.currency.rate via the standard base path if the probe
   * fetch fails.
   */
  async _ensureProbeRate() {
    if (this.state._probeRate)        return this.state._probeRate;
    if (this.state._probeRatePromise) return this.state._probeRatePromise;

    const probeCfg = this.config.priceProbe;
    if (!probeCfg?.handle || !probeCfg?.usdValue) return null;

    const currency = (() => {
      try { return String(window.Shopify?.currency?.active || 'XXX').toUpperCase(); }
      catch (_) { return 'XXX'; }
    })();

    // USD market doesn't need a probe — rate is 1.
    if (currency === 'USD') {
      this.state._probeRate = { rate: 1, source: 'usd-passthrough', currency };
      return this.state._probeRate;
    }

    const cacheKey = `pm:probe:${probeCfg.handle}:${currency}`;
    try {
      const cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        const parsed = JSON.parse(cached);
        if (parsed?.rate > 0) {
          this.state._probeRate = parsed;
          if (this.config.debug) {
            console.log('[PreorderManager] probe rate cache hit:', parsed);
          }
          return parsed;
        }
      }
    } catch (_) { /* fall through */ }

    const promise = (async () => {
      try {
        const res = await fetch(`/products/${encodeURIComponent(probeCfg.handle)}.js`, {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' },
        });
        if (!res.ok) {
          if (this.config.debug) {
            console.warn('[PreorderManager] probe fetch failed:', probeCfg.handle, 'HTTP', res.status);
          }
          this.state._probeRatePromise = null;
          return null;
        }
        const product = await res.json();

        let probeCentsLocalized = null;
        for (const v of (product.variants || [])) {
          if (v?.price != null) {
            const cents = parseInt(v.price, 10);
            if (Number.isFinite(cents) && cents > 0) {
              probeCentsLocalized = cents;
              break;
            }
          }
        }
        if (probeCentsLocalized == null) {
          if (this.config.debug) {
            console.warn('[PreorderManager] probe product had no usable price:', probeCfg.handle);
          }
          this.state._probeRatePromise = null;
          return null;
        }

        const probeLocalized = probeCentsLocalized / 100;
        const rate = probeLocalized / probeCfg.usdValue;
        const entry = {
          rate, source: 'probe', currency,
          probe: { handle: probeCfg.handle, usdValue: probeCfg.usdValue, localized: probeLocalized },
        };

        try { sessionStorage.setItem(cacheKey, JSON.stringify(entry)); } catch (_) {}
        this.state._probeRate = entry;

        if (this.config.debug) {
          let shopifyRate = null;
          try { shopifyRate = Number(window.Shopify?.currency?.rate); } catch (_) {}
          console.log('[PreorderManager] probe rate computed:', {
            ...entry,
            shopifyDisplayRate: shopifyRate,
            divergence: shopifyRate ? +(rate - shopifyRate).toFixed(6) : null,
          });
        }
        return entry;
      } catch (err) {
        if (this.config.debug) console.warn('[PreorderManager] probe fetch error:', err);
        this.state._probeRatePromise = null;
        return null;
      }
    })();

    this.state._probeRatePromise = promise;
    return promise;
  },

  /**
   * Synchronously resolve a preorder discount using the cached probe rate.
   * Returns null when the product hasn't opted in (`useProbeRateDiscount`),
   * or the probe rate hasn't loaded yet — callers fall through to the
   * next path in that case.
   */
  _resolveProbePreorderDiscount(state) {
    const cfg = this.getProductConfig();
    if (!cfg?.useProbeRateDiscount) return null;

    const probe = this.state._probeRate;
    if (!probe?.rate || probe.rate <= 0) return null;

    // Reuse the USD-based discount config (default / double / state-keyed)
    // — same data the Shopify.currency.rate fallback would consume, just
    // with a probe-derived rate this time.
    const usdDiscount = this._resolveBasePreorderDiscount(state);
    if (!usdDiscount || usdDiscount.type !== 'fixed' || usdDiscount.amount == null) {
      return null;
    }

    const localizedAmount = usdDiscount.amount * probe.rate;
    if (this.config.debug) {
      console.log('[PreorderManager] probe-rate discount:', {
        state, usdAmount: usdDiscount.amount, rate: probe.rate,
        localizedAmount: +localizedAmount.toFixed(4),
      });
    }
    return { type: 'fixed', amount: localizedAmount, _localized: true, _viaProbe: true };
  },

  /**
   * Fetch and memoize localized prices for both the main and pre-order
   * products. Returns { main, preorder } on success, null on failure.
   * Subsequent calls return the cached promise / value.
   */
  async _ensureLocalizedPrices() {
    if (this.state._localizedPrices)        return this.state._localizedPrices;
    if (this.state._localizedPricesPromise) return this.state._localizedPricesPromise;

    const cfg = this.getProductConfig();
    if (!cfg) return null;

    const mainHandle     = this.getProductHandle();
    const preorderHandle = this.getPreorderHandle();

    // Per-product fallback maps. When a handle isn't configured, we
    // still know the variant IDs from the product config and can
    // pull localized prices directly via Storefront GraphQL.
    const mainIdMap     = cfg.IDS         || null;
    const preorderIdMap = cfg.preorderIDS || null;

    // Bail only when we have NO way to look up preorder prices —
    // neither a handle nor a variant-id map. Without one of these
    // the exact-discount math can't run and we'd fall back to base
    // USD × Shopify.currency.rate (which silently drifts when
    // localized prices have manual overrides).
    if (!preorderHandle && !preorderIdMap) {
      if (this.config.debug) {
        console.warn('[PreorderManager] no preorder handle OR preorderIDS for', mainHandle,
          '— add an entry to config.preorderHandles, or set preorderProductHandle / preorderIDS on the product config.');
      }
      return null;
    }

    /**
     * Resolve one side (main / preorder) by trying, in order:
     *   1. GraphQL by handle  (precise, when handle is configured)
     *   2. GraphQL by variant IDs (precise, no handle needed)
     *   3. REST by handle  (rounded to 2 decimals, last-resort fallback)
     * Returns null if every attempt fails.
     */
    const fetchOne = async (handle, idMap, label) => {
      if (handle) {
        const precise = await this._fetchPreciseVariantPricesByHandle(handle);
        if (precise) return precise;
      }
      if (idMap) {
        const preciseByIds = await this._fetchPreciseVariantPricesByVariantIds(idMap);
        if (preciseByIds) return preciseByIds;
      }
      if (handle) {
        return this._fetchLocalizedPricesByHandle(handle);
      }
      if (this.config.debug) {
        console.warn('[PreorderManager]', label, 'price lookup failed — no handle and GraphQL by variant IDs returned no data.');
      }
      return null;
    };

    const promise = (async () => {
      const [main, preorder] = await Promise.all([
        fetchOne(mainHandle,     mainIdMap,     'main'),
        fetchOne(preorderHandle, preorderIdMap, 'preorder'),
      ]);
      if (!main || !preorder) {
        if (this.config.debug) {
          console.warn('[PreorderManager] localized price fetch incomplete:',
            { mainVariants:     main     ? Object.keys(main).length     : 0,
              preorderVariants: preorder ? Object.keys(preorder).length : 0 });
        }
        this.state._localizedPricesPromise = null;
        return null;
      }
      this.state._localizedPrices = { main, preorder };
      if (this.config.debug) {
        console.log('[PreorderManager] localized prices fetched:',
          { source: { main: main._source || 'rest', preorder: preorder._source || 'rest' },
            prices: this.state._localizedPrices });
      }
      return this.state._localizedPrices;
    })();

    this.state._localizedPricesPromise = promise;
    return promise;
  },

  /**
   * Compute the exact pre-order discount (in the displayed currency) for a
   * Kaching bar, using fetched localized variant prices. Returns null when
   * data isn't ready or any variant can't be resolved — callers fall back
   * to the discount-math path in that case.
   */
  /**
   * Recover the UNROUNDED bar total from a per-item subtitle when present.
   *
   * Kaching renders bundle bars with a rounded sale price like "€155,71"
   * but often shows the unrounded per-item price in the subtitle:
   *
   *   <div class="kaching-bundles__bar-subtitle">FLASH SALE - €77,86 EACH</div>
   *
   * Multiplying €77,86 by 2 gives €155,72 — the true bar total cart uses
   * internally. Reading from the subtitle instead of the displayed bar
   * price recovers the cent Kaching's main display rounds away.
   *
   * Returns null when no "X each" pattern is found, or the bar has no
   * variant blocks to derive a quantity from. Callers fall back to the
   * rounded displayed bar sale.
   */
   _readPreciseBarTotal(bar) {
    if (!bar) return null;

    // Resolve this bar's total quantity (used by both strategies).
    const blocks = Array.from(bar.querySelectorAll(this.config.kaching.variantBlockSelector));
    const cfg = this.getProductConfig();
    const dealId = bar.getAttribute('data-deal-bar-id') || '';
    const qtyPerBlock = (blocks.length === 1 && dealId === cfg?.DOUBLE_ID) ? 2 : 1;
    const totalQty = blocks.length * qtyPerBlock;

    // ─── Strategy 1: Per-item "each" subtitle ───────────────────────
    // Matches the English "each"/"ea" and the Spanish "cada"/"c/u"
    // wording so the precise-total recovery works on /es-es/ too.
    const subtitleText = bar.querySelector('.kaching-bundles__bar-subtitle')?.textContent || '';
    const eachMatch = subtitleText.match(/([\d][\d.,\s]*[.,]\d{2})\s*(?:each|ea|cada uno|cada|c\/u|c\.u\.)\b/i);
    if (eachMatch && totalQty > 0) {
      const perItem = this.parsePriceToNumber(eachMatch[1]);
      if (!isNaN(perItem) && perItem > 0) {
        const total = perItem * totalQty;
        if (this.config.debug) {
          console.log('[PreorderManager] precise bar total from "each" subtitle:',
            { subtitle: subtitleText.trim(), perItem, totalQty, total });
        }
        return total;
      }
    }

    // ─── Strategy 3: Cart-effective bar from precise math ────────────
    // Reconstruct what cart actually charges for this bundle BEFORE
    // the preorder swap:
    //
    //   cart_bar = Σ main_per_unit_localized × qty
    //              − totalQty × round(disc_USD × rate, 2)
    //
    // Why this matches cart and not the displayed bar:
    // Kaching's bundle bar shows `(Σ main × qty) − (disc_USD × rate × qty)`
    // run through toFixed(2) at the very end — one rounding step on the
    // whole expression. Cart computes the per-unit disc, rounds THAT to
    // 2 decimals, then multiplies. Same inputs, different rounding
    // order → off by ≤ 1¢ when the precise per-unit disc has fractional
    // cents that round in a different direction at the unit level vs
    // the bundle level.
    //
    // Concrete examples observed:
    //   AUD Buy 2: precise disc/unit = $55.3513 → both round to $55.35
    //              → cart_bar = bar_displayed, no drift.
    //   NZD Buy 2: precise disc/unit = $67.3766 → round to $67.38
    //              → cart_bar = $307.24, bar_displayed = $307.25.
    //   GBP Buy 2: similar fractional → bar_displayed 1¢ low vs cart.
    //
    // Using cart's own math here, the preorder label = cart_bar −
    // exact_discount lands on cart's exact value in every currency.
    // Strategy 1 already wins when a subtitle is present (Luhxe), so
    // this branch effectively serves the no-subtitle products (Black
    // Bag, etc).
    const localized = this.state._localizedPrices;
    const dealConfig = this._getKachingDealConfig();
    if (localized?.main?.prices && dealConfig && blocks.length) {
      const cartBar = this._computeCartEffectiveBarTotal(bar, blocks, dealConfig, dealId, qtyPerBlock, totalQty);
      if (cartBar !== null && !isNaN(cartBar)) {
        if (this.config.debug) {
          const { sale } = this.readKachingPrices(bar);
          const displayedNum = this.parsePriceToNumber(sale);
          console.log('[PreorderManager] precise bar total from cart-effective math:',
            { dealId, totalQty, cartBar: +cartBar.toFixed(4),
              barDisplayed: displayedNum,
              divergence: !isNaN(displayedNum) ? +(cartBar - displayedNum).toFixed(4) : null });
        }
        return cartBar;
      }
    }

    // ─── Strategy 2: Non-base-currency multi-qty compensation ────────
    // Empirical +0.01 fallback for products without a subtitle AND
    // without enough config data for Strategy 3 (no Kaching deal
    // block, no localized main prices). Premise: Kaching's bar in
    // non-base currencies displays the sale rounded down 1¢ — add
    // it back.
    //
    // SKIPPED when the product config sets disablePriceCompensation:
    // true. With Strategy 3 in place, this branch is reached only on
    // configuration-missing edge cases, so the flag is rarely needed.
    if (!cfg?.disablePriceCompensation && totalQty > 1) {
      try {
        const rate = parseFloat(window.Shopify?.currency?.rate);
        if (!isNaN(rate) && rate !== 1) {
          const { sale } = this.readKachingPrices(bar);
          const num = this.parsePriceToNumber(sale);
          if (!isNaN(num)) {
            const compensated = num + 0.01;
            if (this.config.debug) {
              console.log('[PreorderManager] 1-cent compensation applied (multi-qty bar, non-base currency):',
                { displayed: num, compensated });
            }
            return compensated;
          }
        }
      } catch (_) {}
    }

    return null;
  },

  /**
   * Read and memoize Kaching's deal config from the
   * `<script class="kaching-bundles-deal-block-settings">` element on
   * the page. Provides per-bar discountType and discountValue, which
   * Strategy 3 uses to reconstruct cart's bundle math.
   *
   * Returns null when the script tag isn't present (non-Kaching page)
   * or the JSON fails to parse.
   */
  _getKachingDealConfig() {
    if (this.state._kachingDealConfig !== undefined) return this.state._kachingDealConfig;
    let cfg = null;
    try {
      const el = document.querySelector('script.kaching-bundles-deal-block-settings');
      if (el?.textContent) cfg = JSON.parse(el.textContent);
    } catch (_) { /* swallow */ }
    this.state._kachingDealConfig = cfg;
    if (this.config.debug && cfg) {
      const summary = (cfg.dealBars || []).map(b => ({
        id: b.id, title: b.title, qty: b.quantity,
        type: b.discountType, value: b.discountValue,
      }));
      console.log('[PreorderManager] kaching deal config:', summary);
    }
    return cfg;
  },

  /**
   * Compute the cart-effective bar total for THIS deal bar, mirroring
   * the math Shopify cart applies for Kaching bundles. Returns the
   * total in display currency, or null when any required piece is
   * missing.
   *
   * Caller (_readPreciseBarTotal) feeds this through the standard
   * preorder calc: preorder = cart_bar − exact_discount.
   */
  _computeCartEffectiveBarTotal(bar, blocks, dealConfig, dealId, qtyPerBlock, totalQty) {
    const localized = this.state._localizedPrices;
    const cfg = this.getProductConfig();
    if (!localized?.main?.prices || !cfg) return null;

    const dealBar = (dealConfig.dealBars || []).find(d => d.id === dealId);
    if (!dealBar) return null;

    // Sum main_per_unit × qty for each variant block in the bar.
    const schema = this.getProductSchema();
    let mainSum = 0;
    for (const block of blocks) {
      const rawColor = schema.colorOptionName
        ? block.querySelector(`.kaching-bundles-option[data-name="${schema.colorOptionName}"]`)?.dataset?.value || null
        : null;
      const rawModel = block.querySelector(`.kaching-bundles-option[data-name="${schema.modelOptionName}"]`)?.dataset?.value || null;
      const canonicalModel = this.normalizeModelValue(rawModel);

      let mainId = null;
      if (localized.main.options) {
        if (rawColor && rawModel && localized.main.options[`${rawColor}|${rawModel}`]) {
          mainId = localized.main.options[`${rawColor}|${rawModel}`];
        } else if (rawModel && localized.main.options[rawModel]) {
          mainId = localized.main.options[rawModel];
        }
      }
      if (!mainId) mainId = this.lookupVariantId(cfg.IDS, rawColor, canonicalModel);
      if (!mainId) return null;

      const mainPrice = localized.main.prices[String(mainId)];
      if (mainPrice == null) return null;
      mainSum += mainPrice * qtyPerBlock;
    }

    // Apply Kaching's discount per its declared type.
    const discType  = dealBar.discountType;
    const discValue = Number(dealBar.discountValue || 0);

    if (!discValue || discType === 'default') {
      // No discount on this deal bar (typical for "Buy 1"). The bar's
      // cart-effective value is just the main sum.
      return mainSum;
    }

    if (discType === 'amount') {
      // Per-unit USD discount, applied as round(disc_USD × rate, 2)
      // per unit in cart. Multiply by totalQty to get the bundle disc.
      const rate = parseFloat(window.Shopify?.currency?.rate);
      if (isNaN(rate)) return null;
      const perUnitLocalized = Math.round(discValue * rate * 100) / 100;
      return mainSum - perUnitLocalized * totalQty;
    }

    if (discType === 'percentage') {
      // Percentage applies to mainSum directly — no rate involved.
      return mainSum * (1 - discValue / 100);
    }

    return null;
  },

  _computeExactPreorderDiscount(bar) {
    const localized = this.state._localizedPrices;
    if (!localized?.main?.prices || !localized?.preorder?.prices) {
      if (this.config.debug && !this.state._exactSkipLogged) {
        this.state._exactSkipLogged = true;
        console.warn('[PreorderManager] exact path unavailable — localized prices not loaded (or fetch failed). Falling back to discount math.');
      }
      return null;
    }

    const cfg = this.getProductConfig();
    if (!cfg) return null;

    const schema = this.getProductSchema();
    const blocks = Array.from(bar.querySelectorAll(this.config.kaching.variantBlockSelector));
    if (!blocks.length) return null;

    const dealId = bar.getAttribute('data-deal-bar-id') || '';
    // Single-block + DOUBLE_ID = BOGO same model (qty 2 of one variant).
    // Multi-block bars (mixed BOGO) keep qty 1 per block.
    const qtyPerBlock = (blocks.length === 1 && dealId === cfg.DOUBLE_ID) ? 2 : 1;

    const getVal = (b, name) =>
      b.querySelector(`.kaching-bundles-option[data-name="${name}"]`)?.dataset?.value || null;

    // Resolve a variant ID for a (rawColor, rawModel) pair. Tries the
    // auto-derived option→ID map from the .js fetch FIRST (uses Shopify's
    // raw option values, always correct for the live product), then falls
    // back to the config IDS as a backup. Lets duplicate landing pages
    // (e.g. luhxe-0, luhxe-1) work without their own correct IDS in
    // config — the script reads the right IDs from each product's own
    // .js response.
    const resolveId = (optionMap, idsMap, rawColor, rawModel, canonicalModel) => {
      if (optionMap) {
        if (rawColor && rawModel) {
          const compositeKey = `${rawColor}|${rawModel}`;
          if (optionMap[compositeKey]) return optionMap[compositeKey];
        }
        if (rawModel && optionMap[rawModel]) return optionMap[rawModel];
      }
      return this.lookupVariantId(idsMap, rawColor, canonicalModel);
    };

    let totalDiscount = 0;
    const breakdown = []; // for debug logging
    for (const block of blocks) {
      const rawColor       = schema.colorOptionName ? getVal(block, schema.colorOptionName) : null;
      const rawModel       = getVal(block, schema.modelOptionName);
      const canonicalModel = this.normalizeModelValue(rawModel);

      const mainId     = resolveId(localized.main.options,     cfg.IDS,         rawColor, rawModel, canonicalModel);
      const preorderId = resolveId(localized.preorder.options, cfg.preorderIDS, rawColor, rawModel, canonicalModel);
      if (!mainId || !preorderId) return null;

      const mainPrice     = localized.main.prices[String(mainId)];
      const preorderPrice = localized.preorder.prices[String(preorderId)];
      if (mainPrice == null || preorderPrice == null) return null;

      const variantDiscount = (mainPrice - preorderPrice) * qtyPerBlock;
      totalDiscount += variantDiscount;
      if (this.config.debug) {
        breakdown.push({
          rawColor, rawModel, canonicalModel, qtyPerBlock,
          mainId: String(mainId), preorderId: String(preorderId),
          mainLocalized: mainPrice, preorderLocalized: preorderPrice,
          variantDiscount: +variantDiscount.toFixed(4),
        });
      }
    }

    // ─── Percentage-deal scaling ─────────────────────────────────────
    // When Kaching applies a percentage discount to the bundle bar
    // (e.g. BOGO = 50% off both items), cart's effective preorder
    // discount is the per-variant diff multiplied by (1 − pct/100):
    //
    //   cart_main_bar     = mainSum × (1 − p/100)
    //   cart_preorder_bar = preorderSum × (1 − p/100)
    //   cart_main − cart_preorder = (mainSum − preorderSum) × (1 − p/100)
    //
    // Without this scaling, "Buy 1 Get 1 Free" bars (50% off bundle)
    // subtract the raw diff and miss cart by (diff × 0.5) — typically
    // shows up as cents-to-low-dollars depending on the per-unit gap
    // between main and preorder prices.
    //
    // Strategy 3 in _readPreciseBarTotal already scales the bar TOTAL
    // by the percentage; this is the matching adjustment for the
    // discount delta. No-op for amount-type deals.
    const dealConfig = this._getKachingDealConfig();
    const dealBar    = dealConfig?.dealBars?.find(d => d.id === dealId);
    let pctScale     = 1;
    if (dealBar?.discountType === 'percentage') {
      const pct = Number(dealBar.discountValue || 0);
      if (pct > 0 && pct < 100) {
        pctScale = 1 - pct / 100;
        totalDiscount *= pctScale;
      }
    }

    if (this.config.debug) {
      const { sale: barSale } = this.readKachingPrices(bar);
      const barSaleNum = this.parsePriceToNumber(barSale);
      const computedDisplay = isNaN(barSaleNum) ? '?' : +(barSaleNum - totalDiscount).toFixed(4);
      console.log('[PreorderManager] exact discount for bar:', {
        dealId, barSale, breakdown,
        dealType: dealBar?.discountType, dealValue: dealBar?.discountValue, pctScale,
        totalDiscount: +totalDiscount.toFixed(4),
        computedPreorderDisplay: computedDisplay,
      });
    }
    return totalDiscount;
  },

  getPreorderPriceDisplay(state) {
    const bar = this.getSelectedBar();
    const { sale, saleBase } = this.readKachingPrices(bar);
    if (!sale) return '';

    // ─── 1. Per-currency override (highest priority) ─────────────────────
    // Amounts here are treated as already in display currency. Defined
    // only where the exact path below disagrees with cart — e.g. The
    // Black Bag in CAD/EUR/GBP, where Kaching's main and preorder
    // bundle deals have different effective discounts that the
    // per-variant-diff math can't recover.
    const perCurrency = this._resolvePerCurrencyPreorderDiscount(state);
    if (perCurrency) {
      return this.applyDiscountToPrice(sale, perCurrency, saleBase);
    }

    // ─── 2. Probe-rate path (opt-in via useProbeRateDiscount) ────────────
    // Computes localized discount as cart-probe-rate × USD amount.
    // Returns null when the product hasn't opted in or the probe rate
    // hasn't loaded yet — caller falls through to the exact path then
    // the base USD × Shopify.currency.rate fallback.
    const probeDiscount = this._resolveProbePreorderDiscount(state);
    if (probeDiscount) {
      return this.applyDiscountToPrice(sale, probeDiscount, saleBase);
    }

    // ─── 3. Exact path — uses fetched localized variant prices ───────────
    // Matches cart to the cent in most currencies. Skipped only when the
    // product config sets useStaticDiscount: true (rare — most products
    // want the exact path with per-currency overrides only where needed).
    const cfg = this.getProductConfig();
    if (bar && !cfg?.useStaticDiscount) {
      const exactDiscount = this._computeExactPreorderDiscount(bar);
      if (exactDiscount !== null) {
        // Prefer the unrounded total from a "X each" subtitle when one is
        // present — recovers the cent Kaching's main display rounds away.
        const preciseTotal = this._readPreciseBarTotal(bar);
        const saleNum = (preciseTotal !== null && !isNaN(preciseTotal))
          ? preciseTotal
          : this.parsePriceToNumber(sale);
        if (!isNaN(saleNum)) {
          return this.replacePriceNumber(sale, this._finalizePreorderNumber(saleNum - exactDiscount));
        }
      }
    }

    // ─── 3. Base-currency (USD) fallback ─────────────────────────────────
    // Last resort: rate-convert the USD amount in preorderDiscount via
    // Shopify.currency.rate. Used when exact prices haven't loaded yet
    // or the fetch failed.
    const discount = this._resolveBasePreorderDiscount(state);
    if (!discount) return sale;
    return this.applyDiscountToPrice(sale, discount, saleBase);
  },

  /* --------------------------------------------------------------------------
   * CART (Shopify AJAX)
   * -------------------------------------------------------------------------- */

  async addMultipleToCart(items, message = '') {
    try {
      const normalized = (items || [])
        .map(it => ({
          id: String(it.variantId ?? it.id ?? ''),
          quantity: Number(it.quantity ?? this.config.defaultQuantity),
        }))
        .filter(it => it.id && it.quantity > 0);
      if (!normalized.length) return null;

      const cartDrawer       = document.querySelector('cart-drawer');
      const cartNotification = document.querySelector('cart-notification');
      const cartElement      = cartDrawer || cartNotification;
      if (!cartElement) return await this.addMultipleToCartSimple(normalized, message);

      let sections = [];
      if (typeof cartElement.getSectionsToRender === 'function') {
        sections = cartElement.getSectionsToRender().map(s => s.id);
      }

      const formData = new FormData();
      normalized.forEach((it, i) => {
        formData.append(`items[${i}][id]`, it.id);
        formData.append(`items[${i}][quantity]`, String(it.quantity));
        formData.append(`items[${i}][properties][${this.config.propertyKey}]`, message);
      });
      if (sections.length) {
        formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      const data = await this._addToCartRequest(formData);
      this.state.lastAddedItem = data?.items?.[data.items.length - 1] || data;

      if (typeof cartElement.renderContents === 'function') {
        cartElement.renderContents(data);
        if (cartDrawer) cartDrawer.classList.remove('is-empty');
      }
      if (this.config.autoOpenCart) {
        await this.delay(250);
        if (typeof cartElement.open === 'function') cartElement.open();
      }
      return data;
    } catch (err) { console.error('addMultipleToCart:', err); throw err; }
  },

  async addToCart(variantId, quantity = null, message = '') {
    try {
      const qty = quantity || this.config.defaultQuantity;
      const cartDrawer       = document.querySelector('cart-drawer');
      const cartNotification = document.querySelector('cart-notification');
      const cartElement      = cartDrawer || cartNotification;
      if (!cartElement) return await this.addToCartSimple(variantId, qty, message);

      let sections = [];
      if (typeof cartElement.getSectionsToRender === 'function') {
        sections = cartElement.getSectionsToRender().map(s => s.id);
      }

      const formData = new FormData();
      formData.append('id', String(variantId));
      formData.append('quantity', String(qty));
      formData.append(`properties[${this.config.propertyKey}]`, message);
      if (sections.length) {
        formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      const data = await this._addToCartRequest(formData);
      this.state.lastAddedItem = data;

      if (typeof cartElement.renderContents === 'function') {
        cartElement.renderContents(data);
        if (cartDrawer) cartDrawer.classList.remove('is-empty');
      }
      if (this.config.autoOpenCart) {
        await this.delay(250);
        if (typeof cartElement.open === 'function') cartElement.open();
      }
      return data;
    } catch (err) { console.error('addToCart:', err); throw err; }
  },

  async _addToCartRequest(formData) {
    const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
    if (!res.ok) {
      let errText = '';
      try { const d = await res.json(); errText = d.description || JSON.stringify(d); }
      catch (_) { errText = await res.text().catch(() => ''); }
      throw new Error(errText || 'Failed to add to cart');
    }
    return await res.json();
  },

  async addMultipleToCartSimple(items, message = '') {
    const formData = new FormData();
    items.forEach((it, i) => {
      formData.append(`items[${i}][id]`, String(it.id));
      formData.append(`items[${i}][quantity]`, String(it.quantity));
      formData.append(`items[${i}][properties][${this.config.propertyKey}]`, message);
    });
    return await this._addToCartRequest(formData);
  },

  async addToCartSimple(variantId, quantity, message) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity, properties: { [this.config.propertyKey]: message } }],
      }),
    });
    if (!res.ok) {
      const errData = await res.json();
      throw new Error(errData.description || 'Failed to add to cart');
    }
    const data = await res.json();
    await this.delay(500);
    await this.clickCartIcon();
    return data;
  },

  async clickCartIcon() {
    const triggers = [
      '#cart-icon-bubble', '[data-cart-drawer-toggle]', '.cart-icon-wrapper',
      '.header__icon--cart', 'a[href="/cart"].header__icon', '.cart-link',
    ];
    for (const sel of triggers) {
      const el = document.querySelector(sel);
      if (el) { el.click(); return true; }
    }
    return false;
  },

  /* --------------------------------------------------------------------------
   * SHIP DATES
   * -------------------------------------------------------------------------- */
  getFutureDate(daysFromNow = null) {
    const days = daysFromNow || this.getDaysUntilShip();
    const d = new Date();
    d.setDate(d.getDate() + days);
    return d;
  },

  /**
   * Locale-aware ship-date formatting.
   *   en → "Jan 5th" / "Jan 5th, 2026"
   *   es → "5 de Ene" / "5 de Ene de 2026"   (no ordinal suffix in Spanish)
   */
  formatShipDate(date) {
    const months = this.getMonthNames();
    const month  = months[date.getMonth()];
    const day    = date.getDate();

    if (this.getLocale() === 'es') {
      if (this.dateConfig.dateFormat === 'long') {
        return `${day} de ${month} de ${date.getFullYear()}`;
      }
      return `${day} de ${month}`;
    }

    const suffix = this.dateConfig.useOrdinalSuffix ? this.getOrdinalSuffix(day) : '';
    if (this.dateConfig.dateFormat === 'long') {
      return `${month} ${day}${suffix}, ${date.getFullYear()}`;
    }
    return `${month} ${day}${suffix}`;
  },

  getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) { case 1: return 'st'; case 2: return 'nd'; case 3: return 'rd'; default: return 'th'; }
  },

  getShipDateMessage(daysFromNow = null) {
    const date = this.formatShipDate(this.getFutureDate(daysFromNow));
    return `${this.config.messagePrefix} ${date}`.trim();
  },

  async addMultipleToCartWithShipDate(items, daysUntilShip = null) {
    const msg = this.getShipDateMessage(daysUntilShip || this.getDaysUntilShip());
    return await this.addMultipleToCart(items, msg);
  },

  async addToCartWithShipDate(variantId, quantity = null, daysUntilShip = null) {
    const msg = this.getShipDateMessage(daysUntilShip || this.getDaysUntilShip());
    return await this.addToCart(variantId, quantity, msg);
  },

  async getCart() {
    const res = await fetch('/cart.js');
    if (!res.ok) throw new Error('Failed to fetch cart');
    const cart = await res.json();
    this.state.cartCount = cart.item_count;
    return cart;
  },

  async clearCart() {
    const res = await fetch('/cart/clear.js', { method: 'POST' });
    if (!res.ok) throw new Error('Failed to clear cart');
    this.state.cartCount = 0;
    return true;
  },

  getState()  { return { ...this.state }; },
  getConfig() { return { ...this.config }; },

  /* --------------------------------------------------------------------------
   * KACHING — OFFER / COLOR / MODEL READERS
   * -------------------------------------------------------------------------- */

  getSelectedBar() {
    return document.querySelector(this.config.kaching.selectedBarSelector);
  },

  getVariantBlocks() {
    const bar = this.getSelectedBar();
    if (!bar) return [];
    return Array.from(bar.querySelectorAll(this.config.kaching.variantBlockSelector));
  },

  getSelectedColors() {
    if (!this.hasColorVariants()) return [];
    const schema = this.getProductSchema();
    const blocks = this.getVariantBlocks();
    if (blocks.length) {
      return blocks
        .map(b => b.querySelector(`.kaching-bundles-option[data-name="${schema.colorOptionName}"]`)?.dataset?.value)
        .filter(Boolean);
    }
    // Legacy fallback (Luhxe only)
    if (document.querySelector('#Color-Charcoal.option-item-active')) return ['Charcoal'];
    if (document.querySelector('#Color-Snow.option-item-active'))     return ['Snow'];
    if (document.querySelector('#Color-Rose.option-item-active'))     return ['Rose'];
    return [];
  },

  isAtcDisabledByColor() {
    if (!this.hasColorVariants()) return false;
    const colors = this.getSelectedColors();
    if (!colors.length) return false;
    const stock = this.getColorStock();
    return colors.some(c => (stock?.[c] ?? 'available') === 'disabled');
  },

  /**
   * Stock map keyed by CANONICAL model name (after normalizeModelValue).
   * Used for products like The Black Bag that have no color option but
   * still want to disable the "Add to cart" path on the regular variants
   * to force pre-order. Same shape as colorStock.
   */
  getModelStock() {
    return this.getProductConfig()?.modelStock || {};
  },

  /**
   * Read the currently-selected canonical model(s). Inspects Kaching's
   * variant blocks first (covers BOGO mixed where multiple models are
   * selected at once), then falls back to the product form.
   */
  getSelectedCanonicalModels() {
    const schema = this.getProductSchema();
    const blocks = this.getVariantBlocks();
    if (blocks.length) {
      const models = blocks
        .map(b => {
          const raw = b.querySelector(`.kaching-bundles-option[data-name="${schema.modelOptionName}"]`)?.dataset?.value;
          return this.normalizeModelValue(raw);
        })
        .filter(Boolean);
      if (models.length) return models;
    }
    const fromForm = this.normalizeModelValue(this.getSelectedModelValue());
    return fromForm ? [fromForm] : [];
  },

  isAtcDisabledByModel() {
    const stock = this.getModelStock();
    if (!stock || !Object.keys(stock).length) return false;
    const models = this.getSelectedCanonicalModels();
    if (!models.length) return false;
    return models.some(m => (stock[m] ?? 'available') === 'disabled');
  },

  /**
   * Unified ATC-disabled check. Returns true when EITHER the selected
   * color OR the selected model is flagged as disabled in the product
   * config. Callers should prefer this over the color- or model-specific
   * variants.
   */
  isAtcDisabled() {
    // Pre-order disabled → every product/variant is treated as in stock,
    // so the ATC button is never disabled by stock status.
    if (this.config.disablePreorder) return false;
    return this.isAtcDisabledByColor() || this.isAtcDisabledByModel();
  },

  /**
   * Resolve the primary variant ID for the current Kaching selection using
   * this product's IDS map (not Kaching's defaultVariantsV2, which can still
   * point at a duplicated source product after a bundle copy).
   */
  resolvePrimaryVariantId() {
    const cfg = this.getProductConfig();
    if (!cfg?.IDS) return null;

    const schema = this.getProductSchema();
    const blocks = this.getVariantBlocks();
    let color    = null;
    let rawModel = null;

    if (blocks.length) {
      const block = blocks[0];
      if (schema.colorOptionName) {
        color = block.querySelector(
          `.kaching-bundles-option[data-name="${schema.colorOptionName}"]`
        )?.dataset?.value || null;
      }
      rawModel = block.querySelector(
        `.kaching-bundles-option[data-name="${schema.modelOptionName}"]`
      )?.dataset?.value || null;
    }
    if (!rawModel) rawModel = this.getSelectedModelValue();

    const model = this.normalizeModelValue(rawModel);
    if (!model) return null;

    return this.lookupVariantId(cfg.IDS, color, model);
  },

  /**
   * Keep GemPages' native product form + ATC buttons aligned with the
   * variant IDs configured for THIS product handle. Fixes duplicate PDPs
   * where Kaching still syncs Rose/Charcoal to sold-out variants on the
   * original luhxe product while Snow still works (old Snow is in stock).
   */
  syncNativeVariantFromSelection() {
    if (!this.usesBypassGemPagesAtc()) return null;

    const variantId = this.resolvePrimaryVariantId();
    if (!variantId) return null;

    const form = this.getGemPagesProductForm();
    const idInput = form?.querySelector('input[name="id"]');
    if (idInput) {
      idInput.value = String(variantId);
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      idInput.dispatchEvent(new Event('input',  { bubbles: true }));
    }

    for (const gpProductButton of this.getGemPagesButtonRoots()) {
      try {
        const raw = gpProductButton.getAttribute('gp-data');
        if (!raw) continue;
        const data = JSON.parse(raw);
        data.variantID = String(variantId);
        gpProductButton.setAttribute('gp-data', JSON.stringify(data));
      } catch (_) {}
    }

    const showAtc = !this.isAtcDisabled();
    this.refreshGemPagesAtcVisibility(showAtc);
    return variantId;
  },

  getGemPagesProductForm() {
    return document.querySelector(
      'product-form.product-form form[data-type="add-to-cart-form"]'
    );
  },

  getGemPagesButtonRoots() {
    const form = document.querySelector('product-form.product-form');
    if (!form) return [];
    return Array.from(form.querySelectorAll('gp-product-button'));
  },

  enableGemPagesAtcButton(btn) {
    if (!btn) return;
    btn.type = 'submit';
    btn.disabled = false;
    btn.removeAttribute('gp-data-hidden');
    btn.removeAttribute('data-state');
    btn.classList.remove('gp-opacity-30', 'btn-disabled', 'gp-cursor-default');
    btn.style.setProperty('display', 'flex', 'important');
    btn.style.setProperty('opacity', '1', 'important');
    btn.style.setProperty('pointer-events', 'auto', 'important');
    btn.style.setProperty('cursor', 'pointer', 'important');
    btn.style.setProperty('background', '#382929', 'important');
    btn.closest('div')?.classList.remove('!gp-hidden');
    btn.closest('div')?.style.setProperty('display', 'block', 'important');
  },

  disableGemPagesSoldOutButton(btn) {
    if (!btn) return;
    btn.setAttribute('gp-data-hidden', 'true');
    btn.disabled = true;
    btn.style.setProperty('display', 'none', 'important');
    btn.closest('div')?.classList.add('!gp-hidden');
    btn.closest('div')?.style.setProperty('display', 'none', 'important');
  },

  refreshGemPagesAtcVisibility(showAtc) {
    // Drop enhancement accidentally applied to sold-out clones.
    document.querySelectorAll('button.gp-button-sold-out.cm-atc-btn').forEach(btn => {
      btn.classList.remove(this.config.atcButton.enhancedClass);
    });

    for (const root of this.getGemPagesButtonRoots()) {
      const atcBtn  = root.querySelector('button.gp-button-atc');
      const soldBtn = root.querySelector('button.gp-button-sold-out');

      if (showAtc) {
        this.enableGemPagesAtcButton(atcBtn);
        this.disableGemPagesSoldOutButton(soldBtn);
      } else {
        if (atcBtn) {
          atcBtn.setAttribute('gp-data-hidden', 'true');
          atcBtn.disabled = true;
          atcBtn.closest('div')?.classList.add('!gp-hidden');
        }
        if (soldBtn) {
          soldBtn.removeAttribute('gp-data-hidden');
          soldBtn.closest('div')?.classList.remove('!gp-hidden');
        }
      }
    }
  },

  /**
   * Read the currently-selected model value from the product form. Returns
   * the RAW value from the DOM (not yet normalized). Callers wanting the
   * canonical key should pass this through normalizeModelValue().
   */
  getSelectedModelValue() {
    const optionName = this.getProductSchema().modelOptionName;
    const group = document.querySelector(`[variant-option-name="${optionName}"]`);
    if (!group) return null;

    const activeLabel = group.querySelector('label.option-item-active');
    const fromLabel = activeLabel?.querySelector('input[type="radio"]')?.value?.trim();
    if (fromLabel) return fromLabel;

    const checked = group.querySelector('input[type="radio"]:checked');
    if (checked?.value) return checked.value.trim();

    const checkedTrue = Array.from(group.querySelectorAll('input[type="radio"]'))
      .find(i => i.getAttribute('checked') === 'true');
    return checkedTrue?.value?.trim() || null;
  },

  getSelectedDealId() {
    return this.getSelectedBar()?.getAttribute('data-deal-bar-id') || '';
  },

  /**
   * Resolve the offer state for a Kaching bar. Without args, uses the
   * currently selected bar. Pass a different bar to read its state (used
   * when injecting pre-order labels on unselected bars).
   * Returns one of:
   *   'single_classic' | 'double_classic'
   *   'single_roller'  | 'double_roller'
   *   'double_mixed'
   *   'none'
   */
  getOfferState(bar = null) {
    const cfg = this.getProductConfig();
    if (!cfg) return 'none';

    const targetBar = bar || this.getSelectedBar();
    if (!targetBar) return 'none';

    const schema = this.getProductSchema();
    const { SINGLE_ID, DOUBLE_ID } = cfg;
    const id     = targetBar.getAttribute('data-deal-bar-id') || '';
    const blocks = Array.from(targetBar.querySelectorAll(this.config.kaching.variantBlockSelector));

    // Mixed BOGO: 2+ variant blocks that include BOTH canonical models
    if (blocks.length >= 2) {
      const models = blocks.map(b => {
        const raw = b.querySelector(`.kaching-bundles-option[data-name="${schema.modelOptionName}"]`)?.dataset?.value;
        return this.normalizeModelValue(raw);
      });
      if (models.includes('Roller Edition') && models.includes('Classic')) {
        return 'double_mixed';
      }
    }

    // Read model from the FIRST block of this bar (or fall back to the form).
    let rawModel = null;
    if (blocks.length) {
      rawModel = blocks[0].querySelector(`.kaching-bundles-option[data-name="${schema.modelOptionName}"]`)?.dataset?.value;
    }
    if (!rawModel) rawModel = this.getSelectedModelValue();

    const canonical = this.normalizeModelValue(rawModel);
    const isClassic = canonical === 'Classic';
    const isRoller  = canonical === 'Roller Edition';

    if (id === SINGLE_ID && isClassic) return 'single_classic';
    if (id === DOUBLE_ID && isClassic) return 'double_classic';
    if (id === SINGLE_ID && isRoller)  return 'single_roller';
    if (id === DOUBLE_ID && isRoller)  return 'double_roller';

    return 'none';
  },

  async waitForInitialOfferState() {
    const maxMs      = this.config.initialSync?.maxMs      ?? 3500;
    const intervalMs = this.config.initialSync?.intervalMs ?? 80;
    const start = Date.now();
    await this.delay(0);
    while ((Date.now() - start) < maxMs) {
      const s = this.getOfferState();
      if (s !== 'none') return s;
      await this.delay(intervalMs);
    }
    return 'none';
  },

  /* --------------------------------------------------------------------------
   * HANDLE SUBMIT (pre-order button click)
   * -------------------------------------------------------------------------- */
  async handleSubmit() {
    const cfg = this.getProductConfig();
    if (!cfg) { console.warn('No product config for', this.getProductHandle()); return; }

    const { IDS, preorderIDS, DOUBLE_ID } = cfg;
    const submitIDS = preorderIDS || IDS;
    const schema    = this.getProductSchema();

    const bar = this.getSelectedBar();
    if (!bar) return;

    const blocks = this.getVariantBlocks();
    const getVal = (b, name) =>
      b.querySelector(`.kaching-bundles-option[data-name="${name}"]`)?.dataset?.value || null;

    if (blocks.length >= 1) {
      const items = [];
      for (const block of blocks) {
        const color    = schema.colorOptionName ? getVal(block, schema.colorOptionName) : null;
        const rawModel = getVal(block, schema.modelOptionName);
        const model    = this.normalizeModelValue(rawModel);
        const id       = this.lookupVariantId(submitIDS, color, model);
        if (!id) { console.warn('Missing variant mapping:', { color, model, rawModel }); continue; }
        items.push({ variantId: id, quantity: 1, model });
      }
      if (!items.length) return;

      // 2+ blocks = BOGO Mixed or similar → each qty 1 via batch path
      if (items.length >= 2) {
        await this.addMultipleToCartWithShipDate(
          items.map(({ variantId, quantity }) => ({ variantId, quantity }))
        );
        return;
      }

      // 1 block: qty depends on deal (BOGO same model = 2, Buy 1 = 1)
      const dealId = this.getSelectedDealId();
      const qty    = (dealId === DOUBLE_ID) ? 2 : 1;
      await this.addToCartWithShipDate(items[0].variantId, qty);
      return;
    }

    // Legacy fallback for Luhxe-style products without Kaching blocks.
    if (!schema.colorOptionName) return; // nothing to do without colors here
    let activeColor = 'Rose';
    if      (document.querySelector('#Color-Charcoal.option-item-active')) activeColor = 'Charcoal';
    else if (document.querySelector('#Color-Snow.option-item-active'))     activeColor = 'Snow';

    const rollerID  = this.lookupVariantId(submitIDS, activeColor, 'Roller Edition');
    const classicID = this.lookupVariantId(submitIDS, activeColor, 'Classic');

    if (
      rollerID && classicID &&
      document.querySelector(
        `${this.config.kaching.barScope} .kaching-bundles__bar--selected .kaching-bundles__bar-container:has([data-value="Roller Edition"]):has([data-value="Classic"])`
      )
    ) {
      await this.addToCartWithShipDate(classicID, 1);
      await this.addToCartWithShipDate(rollerID, 1);
    }
  },

  /**
   * In-stock Add to Cart — same Kaching bundle logic as handleSubmit but uses
   * IDS (not preorderIDS) and skips ship-date line-item properties. Bypasses
   * GemPages' variant picker, which on duplicate PDPs can keep Rose/Charcoal
   * tied to sold-out variants on the source product.
   */
  async handleAtcSubmit() {
    if (!this.usesBypassGemPagesAtc()) return;
    if (this.isAtcDisabled()) return;

    const cfg = this.getProductConfig();
    if (!cfg?.IDS) return;

    try { this.syncNativeVariantFromSelection(); } catch (_) {}

    const { IDS, DOUBLE_ID } = cfg;
    const schema = this.getProductSchema();
    const bar = this.getSelectedBar();
    if (!bar) return;

    const blocks = this.getVariantBlocks();
    const getVal = (b, name) =>
      b.querySelector(`.kaching-bundles-option[data-name="${name}"]`)?.dataset?.value || null;

    if (blocks.length >= 1) {
      const items = [];
      for (const block of blocks) {
        const color    = schema.colorOptionName ? getVal(block, schema.colorOptionName) : null;
        const rawModel = getVal(block, schema.modelOptionName);
        const model    = this.normalizeModelValue(rawModel);
        const id       = this.lookupVariantId(IDS, color, model);
        if (!id) { console.warn('Missing in-stock variant mapping:', { color, model, rawModel }); continue; }
        items.push({ variantId: id, quantity: 1 });
      }
      if (!items.length) return;

      if (items.length >= 2) {
        await this.addMultipleToCart(items.map(({ variantId, quantity }) => ({ variantId, quantity })), '');
        return;
      }

      const dealId = this.getSelectedDealId();
      const qty    = (dealId === DOUBLE_ID) ? 2 : 1;
      await this.addToCart(items[0].variantId, qty, '');
      return;
    }

    const variantId = this.resolvePrimaryVariantId();
    if (variantId) await this.addToCart(variantId, 1, '');
  },

  /* --------------------------------------------------------------------------
   * PREORDER BUTTON
   * -------------------------------------------------------------------------- */
  async bootstrapPreorderButton() {
    if (this.config.disablePreorder) return;
    this.injectPreorderStyles();
    this.injectKachingLabelStyles();
    await this.ensurePreorderButton();
    if (!this.state.observersStarted) {
      this.state.observersStarted = true;
      this.startUnifiedObservers();
    }
    await this.waitForInitialOfferState();
    this.updatePreorderButtonState();
    this.updateKachingBarPreorderLabels();
  },

  injectPreorderStyles() {
    if (this.config.disablePreorder) return;
    if (document.getElementById('cm-preorder-styles')) return;
    const id = this.config.preorderButton.id;
    const style = document.createElement('style');
    style.id = 'cm-preorder-styles';
    style.textContent = `
      #${id} {
        width: 100%;
        display: flex;
        border: 0;
        cursor: pointer;
        border-radius: 15px;
        padding: 16px 18px;
        background: #8A0C0C;
        height: 68px;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        color: #fff;
        text-align: center;
        line-height: 1.1;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
        min-height: fit-content;
      }
      #${id} .cm-preorder-top {
        font-weight: 800;
        font-size: 20px;
        letter-spacing: 0.5px;
        display: inline-flex;
        align-items: baseline;
        justify-content: center;
        gap: 6px;
        flex-wrap: wrap;
      }
      #${id} .cm-preorder-label { text-transform: uppercase; font-size: 20px; }
      #${id} .cm-old,
      #${id} .cm-new          { font-weight: 800; font-size: 20px; }
      #${id} .cm-old {
        opacity: 0.55;
        text-decoration: line-through;
        text-decoration-thickness: 3px;
        text-underline-offset: 4px;
        font-weight: 400;
      }
      #${id} .cm-old:empty,
      #${id} .cm-new:empty    { display: none; }
      #${id}[data-preorder-state="none"] .cm-devider,
      #${id} .cm-new:empty ~ .cm-devider,
      #${id} .cm-old:empty + .cm-new:empty ~ .cm-devider { display: none; }
      #${id} .cm-preorder-bottom {
        margin-top: 2px;
        font-size: 15px;
        font-weight: 400;
        opacity: 0.95;
      }
      #${id} .cm-ship-date { font-weight: 500; }
      #${id}[data-preorder-state="none"] { opacity: 0.92; }
      @media (max-width: 480px) {
        #${id}                        { height: 65px; }
        #${id} .cm-preorder-top       { font-size: 18px; gap: 6px; }
        #${id} .cm-preorder-bottom    { font-size: 14px; margin-top: 4px; }
      }

       .kaching-bundles__block .kaching-bundles__bar-main .kaching-bundles__bar-content .kaching-bundles__bar-pricing .kaching-bundles__bar-price, .kaching-bundles__block .kaching-bundles__bar-main .kaching-bundles__bar-content .kaching-bundles__bar-pricing .kaching-bundles__bar-full-price {
    width: 100% !important;
    text-align: center !important;
    min-width: 85px !important;
}

gp-product-button:after{
	content: '';
	display: block;
	width: 100%;
	padding-bottom: 68.5% !important;
	background-image: url('https://cdn.shopify.com/s/files/1/0607/1733/4575/files/Group_1000009842_1.png?v=1772576289');
	background-repeat: no-repeat;
	background-size: conver;
	background-repeat: no-repeat;
  background-size: cover;
  margin-bottom: 12px;
  margin-top: 20px;
}
  #lux-bundle .lux-usp{
    display: none !important;
  }
    @media (min-width: 600px) {
    #lux-bundle {
        max-width: unset;
        margin: 0;
    }
}
    `;
    document.head.appendChild(style);
  },

  buildPreorderButton() {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.id   = this.config.preorderButton.id;
    btn.setAttribute('data-preorder-state', 'none');
    btn.innerHTML = `
      <div class="cm-preorder-top">
        <span class="cm-preorder-label">${this.t('preorderBtnLabel')}</span>
        <span class="cm-devider">-</span>
        <span class="cm-old"></span>
        <span class="cm-new"></span>
      </div>
      <div class="cm-preorder-bottom">
        <span class="cm-wait">${this.t('waitAndSave')}</span>
        ${this.t('estimatedToShip')} <span class="cm-ship-date"></span>
      </div>
    `;
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.handleSubmit();
    }, true);
    return btn;
  },

  async ensurePreorderButton() {
    if (this.config.disablePreorder) return null;
    const container = await this.waitForSelector(this.config.preorderButton.containerSelector);
    if (!container) return;
    let btn = container.querySelector(`#${this.config.preorderButton.id}`);

    // Pre-order button is shown in EVERY currency. Discount conversion is
    // handled inside applyDiscountToPrice() using either Shopify.currency.rate
    // (Shopify Markets) or the per-element base-currency attribute (Vitals CC).
    if (!btn) {
      btn = this.buildPreorderButton();
      container.appendChild(btn);
      this.state.preorder.mounted = true;
    }
    this.updatePreorderShipDate(btn);
    return btn;
  },

  updatePreorderShipDate(btnEl = null) {
    const btn = btnEl || document.getElementById(this.config.preorderButton.id);
    if (!btn) return;
    const shipSpan = btn.querySelector('.cm-ship-date');
    if (!shipSpan) return;
    shipSpan.textContent = this.formatShipDate(this.getFutureDate());
  },

  updatePreorderButtonState() {
    if (this.config.disablePreorder) return;
    const btn = document.getElementById(this.config.preorderButton.id);
    if (!btn) return;

    const nextState = this.getOfferState();
    btn.setAttribute('data-preorder-state', nextState);
    this.state.preorder.currentState = nextState;

    const { compare } = this.readKachingPrices();
    const preorderPrice = nextState === 'none' ? '' : this.getPreorderPriceDisplay(nextState);

    const oldEl = btn.querySelector('.cm-old');
    const newEl = btn.querySelector('.cm-new');
    if (oldEl) oldEl.textContent = nextState === 'none' ? '' : (compare || '');
    if (newEl) newEl.textContent = preorderPrice;

    this.updatePreorderShipDate(btn);
  },

  /* --------------------------------------------------------------------------
   * ATC BUTTON ENHANCEMENT
   * -------------------------------------------------------------------------- */
  async bootstrapAtcButton() {
    this.injectAtcStyles();
    this.injectBypassGemPagesAtcStyles();
    await this.ensureAtcButtonEnhanced();
    if (!this.state.observersStarted) {
      this.state.observersStarted = true;
      this.startUnifiedObservers();
    }
    await this.waitForInitialOfferState();
    this.updateAtcButtonState();
  },

  injectAtcStyles() {
    if (document.getElementById('cm-atc-styles')) return;
    const sel = `.${this.config.atcButton.enhancedClass}`;
    const style = document.createElement('style');
    style.id = 'cm-atc-styles';
    style.textContent = `
      ${sel} {
        width: 100% !important;
        display: flex !important;
        border: 0 !important;
        cursor: pointer;
        border-radius: 15px !important;
        background: #382929 !important;
        color: #fff !important;
        text-align: center;
        line-height: 1.1;
        user-select: none;
        font-size: 20px;
        -webkit-tap-highlight-color: transparent;
        height: 68px !important;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }
      ${sel} .cm-atc-top {
        font-weight: 800;
        font-size: 20px;
        letter-spacing: 0.5px;
        display: inline-flex;
        align-items: baseline;
        justify-content: center;
        gap: 6px;
        flex-wrap: wrap;
      }
      ${sel} .cm-atc-label{ text-transform: uppercase; font-size: 20px; }
      ${sel} .cm-atc-label.out-of-stock{ display: none !important; }
      ${sel}[data-atc-sold-out="true"] .cm-atc-label.in-stock    { display: none !important; }
      ${sel}[data-atc-sold-out="true"] .cm-atc-label.out-of-stock { display: inline !important; }

      body:has(.kaching-bundles__bar--selected .kaching-bundles__swatch-dropdown[data-name=Color][data-value=Rose]) gp-product-button gp-button button[aria-label="SOLD OUT"]{
            background: #6b6b6b !important;
    opacity: .75;
    pointer-events: none !important;
      }

      ${sel}[aria-label="SOLD OUT"] .cm-atc-label.in-stock    { display: none !important; }
      ${sel}[aria-label="SOLD OUT"] .cm-atc-label.out-of-stock { display: inline !important; }

      ${sel} .cm-old,
      ${sel} .cm-new       { font-weight: 800; font-size: 20px; }
      ${sel} .cm-old {
        opacity: 0.55;
        text-decoration: line-through;
        text-decoration-thickness: 3px;
        text-underline-offset: 4px;
        font-weight: 400;
      }
      ${sel} .cm-old:empty,
      ${sel} .cm-new:empty { display: none; }
      ${sel} .cm-atc-bottom {
        margin-top: 2px;
        font-size: 15px;
        font-weight: 400;
        opacity: 0.95;
        text-transform: capitalize;
      }

      ${sel}[data-atc-sold-out="true"] {
        background: #6b6b6b !important;
        cursor: not-allowed;
        opacity: 0.75;
      }
      ${sel}[data-atc-sold-out="true"] .cm-atc-bottom { display: none !important; }

      ${sel} .cm-atc-sold-out-msg { display: none; }
      ${sel}[data-atc-sold-out="true"] .cm-atc-sold-out-msg:not(:empty) {
        display: block;
        margin-top: 2px;
        font-size: 15px;
        font-weight: 500;
        opacity: 0.95;
        text-transform: capitalize;
      }


      ${sel}[aria-label="SOLD OUT"] {
        background: #6b6b6b !important;
        cursor: not-allowed;
        opacity: 0.75;
      }
      ${sel}[aria-label="SOLD OUT"] .cm-atc-bottom { display: none !important; }

      ${sel} .cm-atc-sold-out-msg { display: none; }
      ${sel}[aria-label="SOLD OUT"] .cm-atc-sold-out-msg:not(:empty) {
        display: block;
        margin-top: 2px;
        font-size: 15px;
        font-weight: 500;
        opacity: 0.95;
        text-transform: capitalize;
      }

      ${sel}[data-atc-state="none"]                 { opacity: 0.92; }
      ${sel}[data-atc-state="none"] .cm-atc-devider { display: none; }
      ${sel} .cm-new:empty ~ .cm-atc-devider        { display: none; }

      @media (max-width: 480px) {
        ${sel}                      { height: 65px !important; }
        ${sel} .cm-atc-top          { font-size: 18px; gap: 6px; }
        ${sel} .cm-atc-bottom       { font-size: 14px; }
        ${sel} .cm-atc-sold-out-msg { font-size: 14px; }
      }
    `;
    document.head.appendChild(style);
  },

  injectBypassGemPagesAtcStyles() {
    if (!this.usesBypassGemPagesAtc()) return;
    if (document.getElementById('cm-atc-bypass-styles')) return;

    const sel = `.${this.config.atcButton.enhancedClass}`;
    const style = document.createElement('style');
    style.id = 'cm-atc-bypass-styles';
    style.textContent = `
      ${sel}.gp-button-atc:not([data-atc-sold-out="true"]) {
        background: #382929 !important;
        opacity: 1 !important;
        cursor: pointer !important;
        pointer-events: auto !important;
      }
    `;
    document.head.appendChild(style);
  },

  buildAtcInnerHTML() {
    return `
      <div class="cm-atc-top">
        <span class="cm-atc-label in-stock">${this.t('atcLabel')}</span>
        <span class="cm-atc-label out-of-stock">${this.t('soldOutLabel')}</span>
        <span class="cm-atc-devider">-</span>
        <span class="cm-old"></span>
        <span class="cm-new"></span>
      </div>
      <div class="cm-atc-bottom">${this.t('inStockReady')}</div>
      <div class="cm-atc-sold-out-msg"></div>
    `;
  },

  async ensureAtcButtonEnhanced() {
    const selector = this.getAtcButtonSelector();
    await this.waitForSelector(selector);

    const btns = document.querySelectorAll(selector);
    const enhanced = [];

    btns.forEach(btn => {
      const isClassed = btn.classList.contains(this.config.atcButton.enhancedClass);
      const hasInner  = !!btn.querySelector('.cm-atc-top');

      if (!isClassed) {
        btn.classList.add(this.config.atcButton.enhancedClass);
        btn.setAttribute('data-atc-state', 'none');
        btn.setAttribute('data-atc-sold-out', 'false');
      }
      if (this.usesBypassGemPagesAtc() && !btn._cmAtcBound) {
        btn._cmAtcBound = true;
        btn.addEventListener('click', (e) => {
          if (btn.getAttribute('data-atc-sold-out') === 'true') {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
          }
          e.preventDefault();
          e.stopImmediatePropagation();
          this.handleAtcSubmit().catch(err => {
            if (this.config.debug) console.error('handleAtcSubmit failed:', err);
          });
        }, true);
      }
      if (!hasInner) {
        btn.innerHTML = this.buildAtcInnerHTML();
      }
      enhanced.push(btn);
    });

    this.state.atc.enhanced = enhanced.length > 0;
    return enhanced;
  },

  /**
   * Humanized list of currently-available colors for the sold-out message.
   * Returns '' for products without colors. Localized: "Available in Rose
   * and Snow" / "Disponible en Rose y Snow" (color names are the Shopify
   * option values, so they stay as-is).
   */
  getAvailableColorsMessage() {
    if (!this.hasColorVariants()) return '';
    const stock = this.getColorStock();
    const available = Object.keys(stock).filter(c => stock[c] === 'available');
    if (available.length === 0) return '';
    const prefix = this.t('availableIn');
    if (available.length === 1) return `${prefix} ${available[0]}`;
    const last = available[available.length - 1];
    const rest = available.slice(0, -1);
    return `${prefix} ${rest.join(', ')} ${this.t('listAnd')} ${last}`;
  },

  updateAtcButtonState() {
    if (this.usesBypassGemPagesAtc()) {
      try { this.syncNativeVariantFromSelection(); } catch (_) {}
    }

    const btns = Array.from(
      document.querySelectorAll(this.getAtcButtonSelector())
    ).filter(b => b.classList.contains(this.config.atcButton.enhancedClass));
    if (!btns.length) return;

    const nextState = this.getOfferState();
    this.state.atc.currentState = nextState;

    const soldOut = this.isAtcDisabled();
    this.state.atc.soldOut = soldOut;

    const { sale, compare } = this.readKachingPrices();

    // Show "Available in X" only when there's truly no other action — i.e.
    // sold out and no pre-order button. Pre-order now exists in every
    // currency, so this is rare.
    const soldOutMsg = soldOut ? this.getAvailableColorsMessage() : '';

    btns.forEach(btn => {
      btn.setAttribute('data-atc-state', nextState);
      btn.setAttribute('data-atc-sold-out', String(soldOut));
      btn.disabled = soldOut;

      if (!soldOut && this.usesBypassGemPagesAtc()) {
        btn.style.setProperty('background', '#382929', 'important');
        btn.style.setProperty('opacity', '1', 'important');
        btn.style.setProperty('cursor', 'pointer', 'important');
        btn.style.setProperty('pointer-events', 'auto', 'important');
      }

      const oldEl = btn.querySelector('.cm-old');
      const newEl = btn.querySelector('.cm-new');
      if (oldEl) oldEl.textContent = (nextState === 'none') ? '' : (compare || '');
      if (newEl) newEl.textContent = (nextState === 'none') ? '' : (sale    || '');

      const bottomEl = btn.querySelector('.cm-atc-bottom');
      if (bottomEl) bottomEl.style.display = soldOut ? 'none' : '';

      const soldOutMsgEl = btn.querySelector('.cm-atc-sold-out-msg');
      if (soldOutMsgEl) soldOutMsgEl.textContent = soldOutMsg;
    });

    if (this.usesBypassGemPagesAtc()) {
      try { this.refreshGemPagesAtcVisibility(!soldOut); } catch (_) {}
    }
  },

  /* --------------------------------------------------------------------------
   * KACHING BAR PRE-ORDER LABELS
   * --------------------------------------------------------------------------
   * Injects a small "Pre-Order: $X" line above each Kaching bar's price.
   * Now works in EVERY currency (uses applyDiscountToPrice with the bar's
   * own base-currency attribute for accurate conversion when available).
   * -------------------------------------------------------------------------- */
  injectKachingLabelStyles() {
    if (this.config.disablePreorder) return;
    if (document.getElementById('cm-kaching-label-styles')) return;
    const style = document.createElement('style');
    style.id = 'cm-kaching-label-styles';
    style.textContent = `
      .cm-kaching-preorder-label {
        display: block;
        font-size: 11px;
        font-weight: 700;
        line-height: 110%;
        margin-bottom: 2px;
        color: inherit;
      }
    `;
    document.head.appendChild(style);
  },

  updateKachingBarPreorderLabels() {
    if (this.config.disablePreorder) return;
    if (!this.config.kaching?.showPreorderLabels) return;
    if (!this.getProductConfig()) return;

    const labelClass = 'cm-kaching-preorder-label';
    const prefix     = this.config.kaching.preorderLabelPrefix || this.t('preorderLabelPrefix');
    const allBars    = document.querySelectorAll('.kaching-bundles__bar');

    for (const bar of allBars) {
      const priceContainer = bar.querySelector('.kaching-bundles__bar-price');
      if (!priceContainer) continue;

      const existing = priceContainer.querySelector(`.${labelClass}`);

      const state = this.getOfferState(bar);
      if (state === 'none') {
        if (existing) existing.remove();
        continue;
      }

      // Read this bar's own live sale price + base-currency original.
      const { sale: saleText, saleBase } = this.readKachingPrices(bar);
      if (!saleText) {
        if (existing) existing.remove();
        continue;
      }

      // ─── 1. Per-currency override (highest priority) ─────────────
      // See getPreorderPriceDisplay for full rationale. Treated as
      // already-localized; bypasses exact path entirely when defined.
      let preorderPrice = null;
      const perCurrency = this._resolvePerCurrencyPreorderDiscount(state);
      if (perCurrency) {
        preorderPrice = this.applyDiscountToPrice(saleText, perCurrency, saleBase);
      }

      // ─── 2. Probe-rate path (opt-in) ─────────────────────────────
      // See getPreorderPriceDisplay for full rationale.
      if (!preorderPrice) {
        const probeDiscount = this._resolveProbePreorderDiscount(state);
        if (probeDiscount) {
          preorderPrice = this.applyDiscountToPrice(saleText, probeDiscount, saleBase);
        }
      }

      // ─── 3. Exact path (fetched localized prices) ────────────────
      // Skipped when useStaticDiscount: true.
      if (!preorderPrice) {
        const useStatic = this.getProductConfig()?.useStaticDiscount;
        const exactDiscount = useStatic ? null : this._computeExactPreorderDiscount(bar);
        if (exactDiscount !== null) {
          // Prefer the unrounded total from a "X each" subtitle when one is
          // present — recovers the cent Kaching's main display rounds away.
          const preciseTotal = this._readPreciseBarTotal(bar);
          const saleNum = (preciseTotal !== null && !isNaN(preciseTotal))
            ? preciseTotal
            : this.parsePriceToNumber(saleText);
          if (!isNaN(saleNum)) {
            preorderPrice = this.replacePriceNumber(saleText, this._finalizePreorderNumber(saleNum - exactDiscount));
          }
        }
      }

      // ─── 4. Base-currency (USD) fallback ─────────────────────────
      if (!preorderPrice) {
        const discount = this._resolveBasePreorderDiscount(state);
        if (!discount) {
          if (existing) existing.remove();
          continue;
        }
        preorderPrice = this.applyDiscountToPrice(saleText, discount, saleBase);
      }

      if (!preorderPrice || preorderPrice === saleText) {
        if (existing) existing.remove();
        continue;
      }

      const labelText = `${prefix} ${preorderPrice}`;
      if (existing) {
        if (existing.textContent !== labelText) existing.textContent = labelText;
      } else {
        const label = document.createElement('span');
        label.className = labelClass;
        label.textContent = labelText;
        priceContainer.insertBefore(label, priceContainer.firstChild);
      }
    }
  },

  /* --------------------------------------------------------------------------
   * STICKY ATC BAR
   * -------------------------------------------------------------------------- */
  async bootstrapStickyAtc() {
    this.injectStickyStyles();
    await this.ensureStickyBar();
    this.bindStickyCtaClicks();
    this.bindStickyScrollObserver();
    this.updateStickyUI();
  },

  injectStickyStyles() {
    if (document.getElementById('cm-sticky-styles')) return;
    const id = this.config.stickyAtc.id;
    const style = document.createElement('style');
    style.id = 'cm-sticky-styles';
    style.textContent = `
      #${id} {
        transform: translateY(100%);
        opacity: 0;
        transition: transform 0.18s cubic-bezier(0.22,1,0.36,1), opacity 0.18s ease;
      }
      #${id}.is-visible {
        transform: translateY(0);
        opacity: 1;
      }

      /* Main CTA sold-out state */
      #${id} #atcBtnMain.sticky-atc__btn--sold-out {
        background: #6b6b6b !important;
        opacity: 0.7;
        cursor: not-allowed;
        pointer-events: none;
      }

      /* Spinner */
      .sticky-atc__spinner {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        vertical-align: middle;
        line-height: 1;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .sticky-atc__spinner svg { animation: stickyAtcSpin 0.7s linear infinite; }
      @keyframes stickyAtcSpin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
      .sticky-atc__btn--loading { opacity: 0.75; pointer-events: none; cursor: default; }
    `;
    document.head.appendChild(style);
  },

  buildStickyBarHTML() {
    const id = this.config.stickyAtc.id;
    // Pre-order disabled → omit the pre-order CTA entirely; only the regular
    // Add-to-cart button remains in the sticky bar.
    const preorderCtaHTML = this.config.disablePreorder ? '' : `
            <button class="sticky-atc__btn sticky-atc__btn--red"  id="atcBtnPreorder" type="button">
              <span class="sticky-atc__btn-label">${this.t('stickyPreorder')}</span>
              <span class="sticky-atc__btn-sub">${this.t('stickyShipsSoon')}</span>
            </button>`;
    return `
      <div class="sticky-atc" id="${id}" role="region" aria-label="${this.t('stickyAria')}">
        <div class="sticky-atc__inner">
          <div class="sticky-atc__info">
            <div class="sticky-atc__thumb" id="atcThumb"></div>
            <div class="sticky-atc__meta">
              <span class="sticky-atc__variant" id="atcVariant">${this.t('stickyLoading')}</span>
              <span class="sticky-atc__deal">&mdash;</span>
            </div>
            <div class="sticky-atc__price">
              <span class="sticky-atc__price-current" id="atcPrice">&mdash;</span>
              <span class="sticky-atc__price-was"    id="atcCompare"></span>
            </div>
          </div>
          <div class="sticky-atc__ctas">
            <button class="sticky-atc__btn sticky-atc__btn--dark" id="atcBtnMain" type="button">
              <span class="sticky-atc__btn-label" id="atcBtnMainLabel">${this.t('stickyAddToCart')}</span>
              <span class="sticky-atc__btn-sub"   id="atcBtnMainSub">${this.t('inStockReady')}</span>
            </button>${preorderCtaHTML}
          </div>
        </div>
      </div>
    `;
  },

  async ensureStickyBar() {
    const id = this.config.stickyAtc.id;
    if (!document.getElementById(id)) {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = this.buildStickyBarHTML().trim();
      document.body.appendChild(wrapper.firstElementChild);
      this.state.sticky.mounted = true;
    }
    this.cacheStickyElements();
  },

  cacheStickyElements() {
    const root = document.getElementById(this.config.stickyAtc.id);
    if (!root) { this.state.sticky.els = null; return; }
    const els = {
      stickyAtc:       root,
      atcThumb:        root.querySelector('#atcThumb'),
      atcVariant:      root.querySelector('#atcVariant'),
      atcDeal:         root.querySelector('.sticky-atc__deal'),
      atcPrice:        root.querySelector('#atcPrice'),
      atcCompare:      root.querySelector('#atcCompare'),
      atcBtnMain:      root.querySelector('#atcBtnMain'),
      atcBtnMainLabel: root.querySelector('#atcBtnMainLabel'),
      atcBtnMainSub:   root.querySelector('#atcBtnMainSub'),
      atcBtnPreorder:  root.querySelector('#atcBtnPreorder'),
    };
    els.atcBtnPreLabel = els.atcBtnPreorder?.querySelector('.sticky-atc__btn-label') || null;
    els.atcBtnPreSub   = els.atcBtnPreorder?.querySelector('.sticky-atc__btn-sub')   || null;
    this.state.sticky.els = els;
  },

  /**
   * Resolve the thumbnail for the currently selected variant.
   * Supports two key formats in variantImages / defaultVariantImages:
   *   • "Color|Model"  — when the product has a color option
   *   • "Model"        — flat, for products without color
   * Falls back to the swatch color if defined.
   */
  readStickyVariantImage() {
    const bar = this.getSelectedBar();
    if (!bar) return null;

    const schema = this.getProductSchema();
    const colorEl = schema.colorOptionName
      ? bar.querySelector(`.kaching-bundles-option[data-name="${schema.colorOptionName}"]`)
      : null;
    const modelEl = bar.querySelector(`.kaching-bundles-option[data-name="${schema.modelOptionName}"]`);
    const color    = colorEl?.getAttribute('data-value');
    const rawModel = modelEl?.getAttribute('data-value');
    const model    = this.normalizeModelValue(rawModel);

    if (model) {
      const productImages = this.getProductConfig()?.variantImages || {};
      const defaultImages = this.config.stickyAtc?.defaultVariantImages || {};
      const merged = { ...defaultImages, ...productImages };

      const candidateKeys = color
        ? [`${color}|${model}`, model]
        : [model];
      for (const key of candidateKeys) {
        if (merged[key]) return { type: 'img', url: merged[key] };
      }
    }

    // Swatch fallback only for products with a color option
    if (schema.colorOptionName) {
      const swatchEl = bar.querySelector(`.kaching-bundles-option[data-name="${schema.colorOptionName}"] .kaching-bundles__swatch`);
      if (swatchEl) {
        const style = swatchEl.getAttribute('style') || '';
        const m = style.match(/--kaching-swatch-color:\s*([^;]+)/);
        if (m) return { type: 'color', value: m[1].trim() };
      }
    }
    return null;
  },

  updateStickyUI() {
    const els = this.state.sticky.els;
    if (!els?.stickyAtc) return;

    const bar = this.getSelectedBar();
    if (!bar) return;

    const { sale, compare } = this.readKachingPrices();
    const offerState        = this.getOfferState();
    const soldOut           = this.isAtcDisabled();

    els.stickyAtc.setAttribute('data-sticky-state',    offerState);
    els.stickyAtc.setAttribute('data-sticky-sold-out', String(soldOut));

    // ─── Thumbnail ──────────────────────────────────────────────────────
    const vi = this.readStickyVariantImage();
    if (els.atcThumb && vi) {
      if (vi.type === 'img') {
        els.atcThumb.style.cssText = '';
        let img = els.atcThumb.querySelector('img');
        if (!img) {
          img = document.createElement('img');
          img.alt = '';
          els.atcThumb.appendChild(img);
        }
        const url = vi.url.replace(/(\?.*)?$/, '?width=80');
        if (img.src !== url) img.src = url;
      } else if (vi.type === 'color') {
        els.atcThumb.style.cssText = `background:${vi.value};background-image:none;border-radius:50%`;
      }
    }

    // ─── Variant label + deal title ─────────────────────────────────────
    const schema = this.getProductSchema();
    const colorEl = schema.colorOptionName
      ? bar.querySelector(`.kaching-bundles-option[data-name="${schema.colorOptionName}"]`)
      : null;
    const modelEl = bar.querySelector(`.kaching-bundles-option[data-name="${schema.modelOptionName}"]`);
    const parts = [];
    if (modelEl?.getAttribute('data-value')) parts.push(modelEl.getAttribute('data-value'));
    if (colorEl?.getAttribute('data-value')) parts.push(colorEl.getAttribute('data-value'));
    if (els.atcVariant) els.atcVariant.textContent = parts.join(' \u00b7 ') || '\u2014';

    const dealTitle = bar.querySelector('.kaching-bundles__bar-title')?.textContent?.trim() || '';
    const dealLabel = bar.querySelector('.kaching-bundles__bar-label')?.textContent?.trim() || '';
    if (els.atcDeal) els.atcDeal.textContent = dealTitle || dealLabel || '';

    // ─── Prices ─────────────────────────────────────────────────────────
    if (els.atcPrice)   els.atcPrice.textContent   = sale    || '\u2014';
    if (els.atcCompare) els.atcCompare.textContent = compare || '';

    // ─── Main ATC CTA ───────────────────────────────────────────────────
    const showPrice = sale || '';
    if (els.atcBtnMain) {
      if (soldOut) {
        els.atcBtnMain.classList.add('sticky-atc__btn--sold-out');
        els.atcBtnMain.disabled = true;
        if (els.atcBtnMainLabel) {
          els.atcBtnMainLabel.textContent = showPrice
            ? `${this.t('stickySoldOut')} \u00b7 ${showPrice}`
            : this.t('stickySoldOut');
        }
        if (els.atcBtnMainSub) {
          els.atcBtnMainSub.textContent = this.t('stickyPreorderNow');
        }
      } else {
        els.atcBtnMain.classList.remove('sticky-atc__btn--sold-out');
        els.atcBtnMain.disabled = false;
        if (els.atcBtnMainLabel) {
          els.atcBtnMainLabel.textContent = showPrice
            ? `${this.t('stickyAddToCart')} \u00b7 ${showPrice}`
            : this.t('stickyAddToCart');
        }
        if (els.atcBtnMainSub) {
          els.atcBtnMainSub.textContent = this.t('inStockReady');
        }
      }
    }

    // ─── Pre-order CTA — always shown, in every currency ────────────────
    if (els.atcBtnPreorder) {
      const preorderPrice = this.getPreorderPriceDisplay(offerState);
      const shipDate      = this.formatShipDate(this.getFutureDate());
      if (els.atcBtnPreLabel) {
        els.atcBtnPreLabel.textContent = preorderPrice
          ? `${this.t('stickyPreorder')} \u00b7 ${preorderPrice}`
          : this.t('stickyPreorder');
      }
      if (els.atcBtnPreSub) {
        els.atcBtnPreSub.textContent = shipDate
          ? this.t('stickyShipsOn', { date: shipDate })
          : this.t('stickyWaitSave');
      }
    }
  },

  /* ─── Show / Hide ──────────────────────────────────────────────────── */
  showStickyBar() {
    const s = this.state.sticky;
    if (s.visible || !s.els?.stickyAtc) return;
    s.visible = true;
    s.els.stickyAtc.classList.add('is-visible');
  },

  hideStickyBar() {
    const s = this.state.sticky;
    if (!s.visible || !s.els?.stickyAtc) return;
    s.visible = false;
    s.els.stickyAtc.classList.remove('is-visible');
  },

  syncStickyVisibility() {
    const trigger = this.state.sticky.trigger;
    if (!trigger || !trigger.isConnected) return;
    const rect = trigger.getBoundingClientRect();
    if (rect.bottom < 0) this.showStickyBar();
    else                 this.hideStickyBar();
  },

  _resolveStickyTrigger() {
    const list = this.config.stickyAtc.triggerSelectors || [];
    for (const sel of list) {
      const el = document.querySelector(sel);
      if (el) return el;
    }
    return null;
  },

  bindStickyScrollObserver() {
    const trigger = this._resolveStickyTrigger();
    if (!trigger) return;

    if (this.state.sticky.trigger === trigger && this.state.sticky.io) return;

    this.state.sticky.trigger = trigger;

    if ('IntersectionObserver' in window) {
      if (this.state.sticky.io) this.state.sticky.io.disconnect();
      this.state.sticky.io = new IntersectionObserver((entries) => {
        const e = entries[0];
        if (!e) return;
        if (e.isIntersecting) this.hideStickyBar();
        else if (e.boundingClientRect.bottom < 0) this.showStickyBar();
        else this.hideStickyBar();
      }, { threshold: 0, rootMargin: '0px' });
      this.state.sticky.io.observe(trigger);

      const footer = document.querySelector(this.config.stickyAtc.footerSelector);
      if (footer && !this.state.sticky.footerIo) {
        this.state.sticky.footerIo = new IntersectionObserver((entries) => {
          if (entries[0]?.isIntersecting) this.hideStickyBar();
          else this.syncStickyVisibility();
        }, { threshold: 0, rootMargin: '0px' });
        this.state.sticky.footerIo.observe(footer);
      }
    } else {
      window.addEventListener('scroll', () => {
        if (this.state.sticky.scrollRaf) return;
        this.state.sticky.scrollRaf = requestAnimationFrame(() => {
          this.state.sticky.scrollRaf = null;
          this.syncStickyVisibility();
        });
      }, { passive: true });
    }
  },

  bindStickyCtaClicks() {
    const els = this.state.sticky.els;
    if (!els) return;

    if (els.atcBtnMain && !els.atcBtnMain._cmBound) {
      els.atcBtnMain._cmBound = true;
      els.atcBtnMain.addEventListener('click', () => {
        if (els.atcBtnMain.disabled) return;
        const pageBtn = document.querySelector('button.gp-button-atc');
        this._stickyFireWithSpinner(els.atcBtnMain, pageBtn);
      });
    }

    if (els.atcBtnPreorder && !els.atcBtnPreorder._cmBound) {
      els.atcBtnPreorder._cmBound = true;
      els.atcBtnPreorder.addEventListener('click', () => {
        const pageBtn = document.getElementById(this.config.preorderButton.id);
        if (!pageBtn) return;
        this._stickyFireWithSpinner(els.atcBtnPreorder, pageBtn);
      });
    }

    if (els.stickyAtc && !els.stickyAtc._cmBound) {
      els.stickyAtc._cmBound = true;
      els.stickyAtc.style.cursor = 'pointer';
      els.stickyAtc.addEventListener('click', (e) => {
        if (e.target.closest('button, a, input, select')) return;
        const target = document.querySelector(this.config.stickyAtc.scrollToSelectorOnTap);
        if (target) {
          const top = target.getBoundingClientRect().top + window.pageYOffset - 16;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      });
    }
  },

  _stickyFireWithSpinner(stickyBtn, pageBtn) {
    if (!stickyBtn || !pageBtn) return;
    if (stickyBtn.classList.contains('sticky-atc__btn--loading')) return;

    stickyBtn.classList.add('sticky-atc__btn--loading');
    const wrap = document.createElement('span');
    wrap.innerHTML = `<span class="sticky-atc__spinner" aria-hidden="true">`
      + `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">`
      + `<circle cx="9" cy="9" r="7" stroke="currentColor" stroke-opacity="0.3" stroke-width="2"/>`
      + `<path d="M9 2a7 7 0 0 1 7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>`
      + `</svg></span>`;
    const spinner = wrap.firstElementChild;
    stickyBtn.appendChild(spinner);

    pageBtn.click();

    setTimeout(() => {
      stickyBtn.classList.remove('sticky-atc__btn--loading');
      if (spinner.parentNode === stickyBtn) stickyBtn.removeChild(spinner);
    }, 2000);
  },

  /* --------------------------------------------------------------------------
   * UNIFIED MUTATION OBSERVER
   * -------------------------------------------------------------------------- */
  startUnifiedObservers() {
    const debounceMs = Math.max(
      this.config.preorderButton?.debounceMs || 120,
      this.config.atcButton?.debounceMs || 120,
    );

    let t = null;
    const debounced = () => {
      if (t) clearTimeout(t);
      t = setTimeout(async () => {
        try { await this.ensurePreorderButton(); }    catch (_) {}
        try { await this.ensureAtcButtonEnhanced(); } catch (_) {}
        this.updatePreorderButtonState();
        this.updateAtcButtonState();
        this.updateKachingBarPreorderLabels();
        if (this.config.stickyAtc?.enabled) {
          try { await this.ensureStickyBar(); } catch (_) {}
          this.bindStickyScrollObserver();
          this.updateStickyUI();
        }
      }, debounceMs);
    };

    const schema = this.getProductSchema();
    const isModelNode = (n) => {
      if (!n || n.nodeType !== 1) return false;
      const sel = `[variant-option-name="${schema.modelOptionName}"]`;
      return (
        n.matches?.(sel) ||
        n.closest?.(sel) ||
        n.querySelector?.(sel)
      );
    };

    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          const el = m.target;
          if (el?.classList?.contains('kaching-bundles__bar')) return debounced();
          if (el?.matches?.('label.option-item'))              return debounced();
          if (
            el?.closest?.('.kaching-bundles__bar-variant-selects') ||
            el?.matches?.('.kaching-bundles-option') ||
            el?.closest?.('.kaching-bundles-option')
          ) return debounced();
        }

        if (m.type === 'childList') {
          const touched = [...(m.addedNodes || []), ...(m.removedNodes || [])];
          if (touched.some(n =>
            n?.nodeType === 1 && (
              n.matches?.('.kaching-bundles__block, .kaching-bundles__bars, .kaching-bundles__bar') ||
              n.querySelector?.('.kaching-bundles__bar') ||
              n.matches?.('.kaching-bundles__bar-price') ||
              n.querySelector?.('.kaching-bundles__bar-price') ||
              n.matches?.(this.config.preorderButton.containerSelector) ||
              n.querySelector?.(this.config.preorderButton.containerSelector) ||
              n.matches?.(this.config.atcButton.selector) ||
              n.querySelector?.(this.config.atcButton.selector) ||
              isModelNode(n)
            )
          )) return debounced();
        }

        if (m.type === 'attributes' && m.attributeName === 'data-value') {
          if (m.target?.closest?.('.kaching-bundles__bar-variant-selects')) return debounced();
        }

        if (
          this.usesBypassGemPagesAtc() &&
          m.type === 'attributes' &&
          m.attributeName === 'gp-data-hidden' &&
          m.target?.matches?.('button.gp-button-atc, button.gp-button-sold-out')
        ) {
          return debounced();
        }
      }
    });

    obs.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'data-value', 'gp-data-hidden'],
    });
  },
};

// ─── Auto-initialize ─────────────────────────────────────────────────────────
(function () {
  const waiter = setInterval(() => {
    if (document && document.body) {
      clearInterval(waiter);
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => window.PreorderManager.init());
      } else {
        window.PreorderManager.init();
      }
    }
  }, 100);
})();
}

let waitForProductForm = setInterval(function(){
  if(document.querySelector('product-form.product-form')){
    clearInterval(waitForProductForm);
    (function () {
  const SELECTORS = [
    '.kaching-bundles .kaching-bundles__bar-variant-select span',
    '.kaching-bundles__swatch-dropdown__option span',
  ];
  const SELECTOR = SELECTORS.join(', ');

  function clean(text) {
    const idx = text.indexOf(' - ');
    if (idx === -1) return null;
    return text.slice(0, idx);
  }

  function fixOne(el) {
    const cleaned = clean(el.innerHTML);
    if (cleaned !== null && cleaned !== el.innerHTML) {
      el.innerHTML = cleaned;
    }
  }

  function fixAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(fixOne);
  }

  fixAll();

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'characterData') {
        const el = m.target.parentElement;
        if (el && el.matches && el.matches(SELECTOR)) fixOne(el);
      }
      if (m.type === 'childList') {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(SELECTOR)) fixOne(node);
          if (node.querySelectorAll) fixAll(node);
        });
        const target = m.target;
        if (target && target.matches && target.matches(SELECTOR)) fixOne(target);
      }
    }
  });

  observer.observe(document.querySelector('product-form.product-form'), {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
  }
},100);